import {
  AccountBalanceWallet,
  AccountBox,
  AccountCircle,
  AssignmentInd,
  AssignmentLate,
  AssignmentTurnedIn,
  AttachMoney,
  Brightness1,
  CheckCircle,
  ConfirmationNumber,
  Dialpad,
  DoneAll,
  Flag,
  GroupAdd,
  HourglassEmpty,
  HowToReg,
  List,
  ListAltOutlined,
  MonetizationOn,
  MoneyOff,
  MoneyOffOutlined,
  RemoveCircle,
  Timer,
  TransferWithinAStation,
} from "@material-ui/icons";
import AssessmentIcon from "@material-ui/icons/Assessment";
import BarChartIcon from "@material-ui/icons/BarChart";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import DateRangeIcon from "@material-ui/icons/DateRange";
import EmojiEventsIcon from "@material-ui/icons/EmojiEvents";
import EmojiPeopleIcon from "@material-ui/icons/EmojiPeople";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import EventNoteIcon from "@material-ui/icons/EventNote";
import GroupIcon from "@material-ui/icons/Group";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import PersonOutlineOutlinedIcon from "@material-ui/icons/PersonOutlineOutlined";
import SettingsIcon from "@material-ui/icons/Settings";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import { ORG_NAME } from "app/appConfig";
import IconConcept from "./Icon/IconConcept";
import IconCountry from "./Icon/IconCountry";
import IconEthnics from "./Icon/IconEthnics";
import IconMapMoney from "./Icon/IconMapMoney";
import IconNotService from "./Icon/IconNotService";
import IconProfession from "./Icon/IconProfession";
import IconServiceRequestSet from "./Icon/IconServiceRequestSet";
import IconServiceType from "./Icon/IconServiceType";
import IconStaff from "./Icon/IconStaff";
import IconUserAccount from "./Icon/IconUserAccount";
import IconUserEdit from "./Icon/IconUserEdit";
import IconVat from "./Icon/IconVat";
import IconDrug from "./Icon/Store/IconDrug";
import IconMedicalEquipment from "./Icon/Store/IconMedicalEquipment";
import IconMedicalSupply from "./Icon/Store/IconMedicalSupply";
export const HIS_DOCTOR = "HIS_DOCTOR"; //bac si
export const HIS_NURSE = "HIS_NURSE"; //dieu duong
export const HIS_SUBCLINICAL = "HIS_SUBCLINICAL"; //can lam sang
export const HIS_LAB_TEST = "HIS_LAB_TEST"; //xet nghiem
export const HIS_RECEPTIONIST = "HIS_RECEPTIONIST";
export const HIS_SALES_CONSULTANT = "HIS_SALES_CONSULTANT"; //tu van vien
export const HIS_SUPER_ADMIN = "HIS_SUPER_ADMIN";
export const HIS_ADMIN = "HIS_ADMIN";
export const HIS_BRANCH_MANAGER = "HIS_BRANCH_MANAGER";
export const HIS_CASHIER = "HIS_CASHIER";
export const HIS_TECHNICIAN = "HIS_TECHNICIAN";
export const HIS_CHIEF_TECHNICIAN = "HIS_CHIEF_TECHNICIAN";
export const HIS_READ_ONLY = "HIS_READ_ONLY";
export const HIS_ACCOUNTANT = "HIS_ACCOUNTANT";
export const HIS_TREATMENT_ASSIGN = "HIS_TREATMENT_ASSIGN";
export const HIS_PAYMENT = "HIS_PAYMENT";
export const HIS_SHOW_FULL_PHONE_NUMBER = "HIS_SHOW_FULL_PHONE_NUMBER";
export const HIS_COPY_PHONE_NUMBER = "HIS_COPY_PHONE_NUMBER";
export const HIS_TEAM_LEAD = "HIS_TEAM_LEAD";
export const HIS_CHECKIN_EDIT_SOURCE = "HIS_CHECKIN_EDIT_SOURCE";
export const HIS_TOUR_RECONCILIATION = "HIS_TOUR_RECONCILIATION";
export const HIS_MANUAL_EXCHANGE = "HIS_MANUAL_EXCHANGE";
export const HIS_CHECKIN_EDIT_ONLY_SOURCE = "HIS_CHECKIN_EDIT_ONLY_SOURCE";
export const HIS_EDIT_WARRANTY = "HIS_EDIT_WARRANTY";
export const HIS_BALANCE_LOCK_OVERRIDE = "HIS_BALANCE_LOCK_OVERRIDE";
export const HIS_EXPORT_EXCEL = "HIS_EXPORT_EXCEL";
export const HIS_VIEW_SENSITIVE_IMAGE = "HIS_VIEW_SENSITIVE_IMAGE";
export const HIS_EDIT_REVENUE_TYPE = "HIS_EDIT_REVENUE_TYPE"; // quyền chỉnh sửa doanh thu mới/cũ
export const HIS_FULL_STAFF_SEARCH = "HIS_FULL_STAFF_SEARCH"; // quyền tìm kiếm toàn bộ nhân viên, không lọc theo visit
export const SERVICE_UNSPECIFIED_DEPOSIT = "SERVICE_UNSPECIFIED_DEPOSIT";
export const PAGESIZE_ALL = 999999;

export const YesOrNo = {
  YES: "yes",
  NO: "no",
};

export const CONCEPT_DATA_TYPE_NUMBERIC = "numeric";
export const CONCEPT_DATA_TYPE_TEXT = "text";
export const CONCEPT_DATA_TYPE_BOOLEAN = "boolean";
export const CONCEPT_DATA_TYPE_CODED = "coded";
export const CONCEPT_DATA_TYPE_MIXED = "mixed";

export const ConceptDataType = {
  NUMERIC: "numeric",
  CODED: "coded",
  MIXED: "mixed",
};

export const AppointmentResourceType = {
  SERVICE: 1,
  DRUG: 2,
  SUPPLIES: 3,
};
export const GENDER_MALE_VALUE = "M";
export const GENDER_FEMALE_VALUE = "F";
export const LIST_GENDER = [
  {
    name: "Nam",
    value: GENDER_MALE_VALUE,
    icon: "♂",
    className: "gender-male",
  },
  {
    name: "Nữ",
    value: GENDER_FEMALE_VALUE,
    icon: "♀",
    className: "gender-female",
  },
];

export const LIST_GENDER_CRM = [
  {
    name: "Nam",
    value: "male",
    valueFormat: "M",
    icon: "♂",
    className: "gender-male",
  },
  {
    name: "Nữ",
    value: "female",
    valueFormat: "F",
    icon: "♀",
    className: "gender-female",
  },
];

export const LIST_GENDER_NUMBER = [
  { name: "Nam", value: 1 },
  { name: "Nữ", value: 2 },
];

export const LIST_CUSTOMER_STATUS = [
  { name: "Khách hàng cũ", value: 1 },
  { name: "Khách hàng mới", value: 2 },
];

//loại hưởng bảo hiểm y tế
export const LIST_PAYMENT_TYPE = [
  { name: "Đúng tuyến", value: "1" },
  { name: "Cấp cứu", value: "2" },
  { name: "Trái tuyến", value: "3" },
  { name: "Thông tuyến", value: "1.2" },
];

//loại bhyt
export const TYPE_INSURANCE = [
  { name: "A. Bệnh nhân đăng ký KCB ban đầu tại cơ sở khám bệnh", value: 1 },
  { name: "B. Bệnh nhân nội tỉnh không đăng ký KCB tại cơ sở KCB", value: 2 },
  { name: "C. Bệnh nhân ngoại tỉnh", value: 3 },
];

export const PathModule = {
  PATIENT_RECEPTION_ROOM: "patient-reception-room",
  VISIT: "visit",
  MANAGEMENT: "management",
  FEE: "fee",
  STAFF: "staff",
  // DRUGSTORE: 'drugstore',
  STORE: "store",
  BOARDING: "boarding",
  REPORT: "report",
  COMMUNITY_EXAMINATION: "community-examination",
  FINANCE: "finance",
  REQUEST_NUMBER: "request-number",
  SUPERSONIC: "supersonic",
  SURGERY_PROCEDURE: "surgery-procedure",
  PUBLIC: "public",
  CUSTOMER_CARE: "customer-care",
  SUBCLINICAL: "subclinical",
  IMGSTUDY: "img-study",
  GROUP_MEDICAL_EXAM: "group-medical-exam",
  DASHBOARD: "dashboard",
  NUTRITION: "nutrition",
  SURGERY: "surgery",
  SHI: "shi",
  EMERGENCY: "emergency",
  ADMINISTRATIVEPATIENT: "administrativePatient",
  PATIENT_MANAGEMENT: "patient-management",
  TREATMENT_MANAGEMENT: "treatment-management",
  MANAGEMENT_CRM: "managementcrm",
  MANAGEMENT_HUMANRESOURCES: "humanresources",
  MANAGEMENT_OPERATE: "managementoperate",
  MANAGEMENT_SUPERSET: "managementsuperset",
  ACCOUNTANT: "accountant",
};

export const PathForPatientInfor = [
  {
    name: PathModule.PATIENT_RECEPTION_ROOM,
    value: PathModule.PATIENT_RECEPTION_ROOM + "/patient-info",
  },
  { name: PathModule.VISIT, value: PathModule.VISIT + "/patient-info" },
  { name: PathModule.BOARDING, value: PathModule.BOARDING + "/patient-info" },
  {
    name: PathModule.CUSTOMER_CARE,
    value: PathModule.CUSTOMER_CARE + "/patient-info",
  },
  { name: PathModule.FEE, value: PathModule.FEE + "/invoice-patient" },
];

export const LevelAdministrative = {
  PROVINCE: 1,
  DISTRICTS: 2,
  WARD: 3,
};

export const LIST_LEVEL_ADMINISTRATIVE = [
  { name: "Tỉnh/Thành phố", value: LevelAdministrative.PROVINCE },
  { name: "Quận/Huyện", value: LevelAdministrative.DISTRICTS },
  { name: "Xã/Phường", value: LevelAdministrative.WARD },
];

export const HAS_EYE_TEST = [
  { name: "Đã đo", value: true },
  { name: "Chưa đo", value: false },
];

export const ENCOUNTER_ROOM_TYPE = "0";
export const RECEPTION_ROOM_TYPE = 5;
export const IMG_STUDY_ROOM_TYPE = 4;
export const LAB_TEST_ROOM_TYPE = 3;
export const Procedures_ROOM_TYPE = 6;

export const LIST_ROOM_TYPES = [
  { name: "Phòng khám", value: ENCOUNTER_ROOM_TYPE },
  { name: "Phòng đo thị lực", value: 1 },
  { name: "Phòng điều trị", value: 2 },
  { name: "Phòng xét nghiệm", value: LAB_TEST_ROOM_TYPE },
  { name: "Phòng Chẩn đoán hình ảnh", value: IMG_STUDY_ROOM_TYPE },
  { name: "Phòng tiếp đón", value: RECEPTION_ROOM_TYPE },
  { name: "Phòng thủ thuật", value: 6 },
  { name: "Phòng bệnh", value: 7 },
  { name: "Phòng phẫu thuật", value: 8 },
  { name: "Phòng kế toán", value: 9 },
  { name: "Phòng đo khúc xạ", value: 10 },
  { name: "Phòng tư vấn", value: 11 },
];

export const PRODUCT_TYPE_STORE = [
  { name: "Thuốc", value: 1 },
  { name: "Vật tư y tế", value: 2 },
  { name: "Trang thiết bị y tế", value: 3 },
  { name: "Sinh phẩm", value: 4 },
  { name: "Máu và chế phẩm máu", value: 7 },
];
export const ABO_GROUP = [
  { name: "A", value: "A" },
  { name: "B", value: "B" },
  { name: "O", value: "O" },
  { name: "AB", value: "AB" },
];
export const RH_GROUP = [
  { name: "RH+", value: "RH+" },
  { name: "RH-", value: "RH-" },
];

export const LIST_SERVICE_GROUP_TYPE = [
  { name: "Xét nghiệm", value: 1 },
  { name: "Chẩn đoán hình ảnh", value: 2 },
];

export const LIST_CLINICAL_AREAS = [
  { name: "Dịch vụ", value: "1" },
  { name: "BHYT/Viện phí", value: "2" },
];
export const LIST_REASON_DEPARTMENT_TRANSFER = [
  { name: "Chuyển khoa điều trị", value: "1" },
  { name: "Bổ sung thuốc, CLS", value: "2" },
];

export const Voucher_Retail_Medication_Collection =
  "Retail_medication_collection";

export const INVOICE_PAID = "Paid";
export const INVOICE_UNPAID = "UnPaid";
export const INVOICE_PARTIAL_PAID = "PartialPaid";
export const INVOICE_NOREQUIRED_PAID = "NoPaymentRequired";

export const isPaid = (item) =>
  item?.value === INVOICE_PAID ||
  item?.value === INVOICE_PARTIAL_PAID ||
  item?.value === INVOICE_NOREQUIRED_PAID;

export const LIST_INVOICE_STATUS_TYPES = [
  {
    value: INVOICE_UNPAID,
    name: "Chưa thanh toán",
    numberValue: 2,
    color: "#ff0000",
    icon: <MoneyOff style={{ color: "#ff0000" }} />,
  },
  {
    value: INVOICE_PARTIAL_PAID,
    name: "Thanh toán 1 phần",
    numberValue: 3,
    color: "#F16321",
    icon: <AttachMoney style={{ color: "#F16321" }} />,
  },
  {
    value: INVOICE_PAID,
    name: "Đã thanh toán",
    numberValue: 1,
    color: "#008000",
    icon: <MonetizationOn style={{ color: "#008000" }} />,
  },
  {
    value: INVOICE_NOREQUIRED_PAID,
    name: "Không cần thanh toán",
    numberValue: 4,
    color: "#0076ff",
    icon: <RemoveCircle style={{ color: "#0076ff" }} />,
  },
];

export const YES_OR_NO = [
  { name: "Có", value: "yes" },
  { name: "Không", value: "no" },
];
export const TRUE_OR_FALSE = [
  { name: "Có", value: 1 },
  { name: "Không", value: 0 },
];

export const TRUE_FALSE = [
  { name: "Có", value: "true", prop: true },
  { name: "Không", value: "false", prop: false },
];
export const TREATMENT_STATUS_WAIT = 1; //Vào viện
export const TREATMENT_STATUS_BEING = 2; // bệnh nhân đang điều trị nội trú
export const TREATMENT_STATUS_BEING_AND_WAITTING = 3; //Đang điều trị và chờ tiếp nhận
export const TREATMENT_STATUS_END_TREATMENT = 4; //Ra viện chưa thanh toán
export const TREATMENT_STATUS_DONE = 5; //Quyết toán và ra viện
export const TREATMENT_STATUS_HOSPITAL_DISCHARGE = 10; //Ra viện/kết thúc điều trị ngoại trú
export const TREATMENT_STATUS_OUTPATIENT_EXAMINATION = 7; //Đang khám ngoại trú
export const TREATMENT_STATUS_BEING_TREATMENT_OUTPATIENT = 12; // bệnh nhân đang điều trị ngoại trú

export const TreatmentStatus = {
  WAIT: TREATMENT_STATUS_WAIT,
  BEING: TREATMENT_STATUS_BEING,
  BEING_AND_WAITTING: TREATMENT_STATUS_BEING_AND_WAITTING,
  END_TREATMENT: TREATMENT_STATUS_END_TREATMENT,
  DONE: TREATMENT_STATUS_DONE,
};

export const TREATMENT_STATUS = [
  { name: "Đang điều trị", value: TREATMENT_STATUS_BEING },
  { name: "Nhập viện - Chờ điều trị", value: TREATMENT_STATUS_WAIT },
  { name: "Mới", value: "0" },
  {
    name: "Chuyển khoa/phòng, chờ tiếp nhận",
    value: TREATMENT_STATUS_BEING_AND_WAITTING,
  },
  { name: "Yêu cầu ra viện", value: TREATMENT_STATUS_END_TREATMENT },
  { name: "Ra viện, đã quyết toán", value: TREATMENT_STATUS_DONE },
];

export const MEDICAL_RECORD_TYPE = [
  { name: "Trường đơn", value: 1 },
  { name: "Danh sách", value: 2 },
];

export const SERVICE_REQUESTSET_TYPE = [
  { name: "Thủ thuật", value: "operation" },
  { name: "Xét nghiệm", value: "lab_test" },
  { name: "Chẩn đoán hình ảnh", value: "diagnostic_imaging" },
  { name: "Phẫu thuật", value: "surgery" },
];

export const CONCEPT_TYPE_PERSONNAL = "personalDiseases";
export const CONCEPT_TYPE_FAMILY = "familyDiseases";
export const CONCEPT_TYPE_RISK_FACTOR = "riskFactor";
export const CONCEPT_TYPE_ALLERGY = "allergy";
export const CONCEPT_TYPE_MEDICAL_HISTORY = "medicalHistory";
export const CONCEPT_TYPE_DIAGNOSTIC = "diagnostic";
export const CONCEPT_TYPE_PHARMACEUTICAL = "pharmaceutical";
export const CONCEPT_TYPE_ALLERGY_DRUG = "drugallergy";
export const CONCEPT_TYPE_MEDICAL_RECORD = "medicalRecord";
export const CONCEPT_TYPE_REFRACTIVE_ERROR = "type-of-refractive-error";
export const CONCEPT_TYPE_INDICATOR_RESULT = "indicator_result";
export const CONCEPT_TYPE_NUMBER = "MKQ";

export const CONCEPT_TYPE = [
  { name: "Tiền sử cá nhân", value: CONCEPT_TYPE_PERSONNAL },
  { name: "Tiền sử gia đình", value: CONCEPT_TYPE_FAMILY },
  { name: "Yếu tố nguy cơ", value: CONCEPT_TYPE_RISK_FACTOR },
  { name: "Dị ứng", value: CONCEPT_TYPE_ALLERGY },
  { name: "Tiền sử bệnh", value: CONCEPT_TYPE_MEDICAL_HISTORY },
  { name: "Hoạt chất", value: CONCEPT_TYPE_PHARMACEUTICAL },
  { name: "Dị ứng thuốc", value: CONCEPT_TYPE_ALLERGY_DRUG },
];

export const END_VISIT_STATUS = "2";
export const ADVISED = "6";

export const REVIEWED_VISIT_STATUS = "5";
export const DISCHARGE_APPROVAL = 3;
export const VISIT_STATUS = [
  {
    name: "Chưa bắt đầu",
    value: "0",
    bgColor: "#0076ff",
    color: "#fff",
    icon: <AccountCircle style={{ color: "#0076ff" }} />,
  },
  {
    name: "Đang khám",
    value: "1",
    bgColor: "#ff8100",
    color: "#fff",
    icon: <AccountBox style={{ color: "#ff8100" }} />,
  },
  {
    name: "Đã kết thúc",
    value: END_VISIT_STATUS,
    bgColor: "green",
    color: "#fff",
    icon: <HowToReg style={{ color: "green" }} />,
  },
  {
    name: "Đã quyết toán",
    value: "3",
    bgColor: "#ff0606",
    color: "#fff",
    icon: <VerifiedUserIcon style={{ color: "#ff0606" }} />,
  },
  {
    name: "Đã duyệt phơi",
    value: "4",
    bgColor: "#ff0606",
    color: "#fff",
    icon: <DoneAll style={{ color: "#ff0606" }} />,
  },
];
export const VISIT_STATUS_INTEGER = [
  {
    name: "Chưa bắt đầu",
    value: 0,
  },
  {
    name: "Đang khám",
    value: 1,
  },
  {
    name: "Đã kết thúc",
    value: 2,
  },
  {
    name: "Đã quyết toán",
    value: 3,
  },
  {
    name: "Đã duyệt phơi",
    value: 4,
  },
];

export const VISIT_STATUS_CAMPAIGN_RECEPTION = [
  {
    name: "Chờ đăng ký",
    value: 1,
  },
  {
    name: "Đã đăng ký",
    value: 2,
  },
  {
    name: "Không đến khám",
    value: -1,
  },
  {
    name: "Đang khám",
    value: 3,
  },
  {
    name: "Đã kết thúc",
    value: 4,
  },
  {
    name: "Tất cả",
    value: null,
  },
];
export const VISIT_STATUS_CAMPAIGN = [
  {
    name: "Chờ khám",
    value: 0,
  },
  {
    name: "Đang khám",
    value: 1,
  },
  {
    name: "Hoàn thành",
    value: 2,
  },
];

export const SUBCLINICAL_STATUS = [
  {
    name: "Chưa có CLS",
    value: "3",
    icon: <IconNotService style={{ color: "gray" }} />,
  },
  {
    name: "Có chỉ định, chưa thực hiện CLS",
    value: "0",
    icon: <Flag style={{ color: "red" }} />,
  },
  {
    name: "Đang thực hiện CLS",
    value: "2",
    icon: <TransferWithinAStation style={{ color: "orange" }} />,
  },
  {
    name: "Đã hoàn thành CLS",
    value: "1",
    icon: <CheckCircle style={{ color: "green" }} />,
  },
];
export const SUBCLINICAL_STATUS_LAB_IMAGE = [
  {
    name: "Chưa hoàn thành",
    value: 0,
  },
  {
    name: "Đã hoàn thành",
    value: 1,
  },
  {
    name: "Đang thực hiện",
    value: 2,
  },
  {
    name: "Chưa có dịch vụ",
    value: 3,
  },
];

export const SUBCLINICAL_STATUS_WAITING = [
  {
    name: "subclinicalStatus.notPerformedLabTest",
    value: "0",
    icon: <Flag style={{ color: "red" }} />,
  },
  {
    name: "subclinicalStatus.completedLabTest",
    value: "1",
    icon: <CheckCircle style={{ color: "green" }} />,
  },
];

export const SURGERY_REQUEST_STATUS = [
  {
    name: "Chờ phê duyệt",
    value: 1,
    icon: <Brightness1 style={{ color: "#f03030" }} />,
  },
  {
    name: "Đã phê duyệt",
    value: 2,
    icon: <Brightness1 style={{ color: "#FF9966" }} />,
  },
  {
    name: "Đã từ chối",
    value: 3,
    icon: <Brightness1 style={{ color: "#lightslategrey" }} />,
  },
  {
    name: "Chờ thông tin bổ sung",
    value: 6,
    icon: <Brightness1 style={{ color: "#4276a4" }} />,
  },
  {
    name: "Đang thực hiện",
    value: 4,
    icon: <Brightness1 style={{ color: "#2ec8c8" }} />,
  },
  {
    name: "Đã thực hiện",
    value: 5,
    icon: <Brightness1 style={{ color: "#66CC66" }} />,
  },
];

export const SERVICE_REQUEST_STATUS_HAS_RESULT = 4;
export const SERVICE_REQUEST_STATUS_RESULTED = 6;
export const SERVICE_REQUEST_STATUS_DOING = 3;

export const LAServiceRequestItemStatusEnum = {
  NEW: {
    value: 1,
    name: "Mới chỉ định",
  },
  RECEIVED: {
    value: 2,
    name: "Đã điều phối",
  },
  PROCESSING: {
    value: 3,
    name: "Đang thực hiện",
  },
  FINISHED: {
    value: 4,
    name: "Đã hoàn thành",
  },

  getListData: function () {
    return Object.values(this).filter(
      (item) => typeof item === "object" && item.name
    );
  },

  fromValue: function (value) {
    return this.getListData().find((item) => item.value === value);
  },
};

export const LATreatmentType = {
  NEW: {
    value: 1,
    name: "Cũ",
  },
  RECEIVED: {
    value: 2,
    name: "Mới",
  },

  getListData: function () {
    return Object.values(this).filter(
      (item) => typeof item === "object" && item.name
    );
  },

  fromValue: function (value) {
    return this.getListData().find((item) => item.value === value);
  },
};

export const LAServiceTreatmentType = {
  Treatment: {
    value: 1,
    name: "Điều trị",
  },
  Warranty: {
    value: 2,
    name: "Bảo hành",
  },

  getListData: function () {
    return Object.values(this).filter(
      (item) => typeof item === "object" && item.name
    );
  },

  fromValue: function (value) {
    return this.getListData().find((item) => item.value === value);
  },
};

export const LAVoucherItemRevenueType = {
  OLD_REVENUE: {
    value: 1,
    name: "Doanh thu cũ",
  },
  NEW_REVENUE: {
    value: 2,
    name: "Doanh thu mới",
  },

  getListData: function () {
    return Object.values(this).filter(
      (item) => typeof item === "object" && item.name
    );
  },

  fromValue: function (value) {
    return this.getListData().find((item) => item.value === value);
  },
};

export const PositionType = {
  TELESALE: {
    value: 1,
    name: "Telesale",
  },
  NOT_TELESALE: {
    value: 2,
    name: "Khác Telesale",
  },

  getListData: function () {
    return Object.values(this).filter(
      (item) => typeof item === "object" && item.name
    );
  },

  fromValue: function (value) {
    return this.getListData().find((item) => item.value === value);
  },
};

export const INTEREST_RATE_TYPE_FACILITY = 1;
export const INTEREST_RATE_TYPE_CUSTOMER = 2;
export const INTEREST_RATE_TYPE = [
  { value: 1, name: "Cơ sở chịu lãi" },
  { value: 2, name: "Khách hàng chịu lãi" },
];

export const SERVICE_REQUEST_STATUS_NEW = 1;
export const SERVICE_REQUEST_STATUS_RECEIVED = 2;
export const SERVICE_REQUEST_STATUS_PROCESSING = 3;
export const SERVICE_REQUEST_STATUS_FINISHED = 4;

export const SERVICE_REQUEST_STATUS = [
  {
    name: "Mới chỉ định",
    value: SERVICE_REQUEST_STATUS_NEW,
    icon: <Brightness1 style={{ color: "#f03030" }} />,
  },
  {
    name: "Đã điều phối",
    value: SERVICE_REQUEST_STATUS_RECEIVED,
    icon: <Brightness1 style={{ color: "#FF9966" }} />,
  },
  {
    name: "Đang thực hiện",
    value: SERVICE_REQUEST_STATUS_PROCESSING,
    icon: <Brightness1 style={{ color: "#2ec8c8" }} />,
  },
  {
    name: "Đã hoàn thành",
    value: SERVICE_REQUEST_STATUS_FINISHED,
    icon: <Brightness1 style={{ color: "#66CC66" }} />,
  },
];

export const SERVICE_REQUEST_STATUS_CAMPAIGN = [
  {
    name: "Mới chỉ định",
    value: 1,
    icon: <Brightness1 style={{ color: "#f03030" }} />,
  },
  {
    name: "Đã lấy mẫu",
    value: 2,
    icon: <Brightness1 style={{ color: "#FF9966" }} />,
  },
  {
    name: "Đã có kết quả",
    value: 4,
    icon: <Brightness1 style={{ color: "#66CC66" }} />,
  },
  {
    name: "Đã trả kết quả",
    value: 6,
    icon: <Brightness1 style={{ color: "#4276a4" }} />,
  },
];

export const SERVICE_REQUEST_ITEM_HAS_RESULT = 4;
export const SERVICE_REQUEST_ITEM_RESULTED = 6;
export const SERVICE_REQUEST_IMAGE_STATUS = [
  {
    name: "Chưa thực hiện",
    value: 0,
    icon: <Brightness1 style={{ color: "#f03030" }} />,
  },
  {
    name: "Đã có kết quả",
    value: SERVICE_REQUEST_ITEM_HAS_RESULT,
    icon: <Brightness1 style={{ color: "#66CC66" }} />,
  },
  {
    name: "Đã trả kết quả",
    value: SERVICE_REQUEST_ITEM_RESULTED,
    icon: <Brightness1 style={{ color: "#4276a4" }} />,
  },
];

export const RESULT_TYPE_FROM_MEDICAL_EQUIPMENT = 2;

export const INVOICE_TYPE_PROVISIONAL_RECEIPT = "ProvisionalReceipt";
export const INVOICE_TYPE_RECEIPT = "Receipt";
export const INVOICE_TYPE_PAYMENT = "Payment";
export const INVOICE_TYPE_DISCHARGEFROMHOSPITAL = "DischargeFromHospital";

export const INVOICE_TYPE = [
  { value: "Receipt", name: "Phiếu thu" },
  { value: "Payment", name: "Phiếu chi" },
  { value: INVOICE_TYPE_PROVISIONAL_RECEIPT, name: "Phiếu tạm thu" },
  { value: INVOICE_TYPE_DISCHARGEFROMHOSPITAL, name: "Quyết toán ra viện" },
];

export const INVOICE_TYPE_BY_ITEM = [
  { value: 1, name: "Dịch vụ" },
  { value: 2, name: "Vật tư y tế" },
  { value: 3, name: "Thuốc" },
  { value: 4, name: "Hỗn hợp" },
];
export const PATIENT_IDENTIFICATION_TYPE = [
  { value: 1, name: "BHYT" },
  { value: 2, name: "CCCD" },
];
// Quyết định 824/QĐ-BYT
export const INSURED_PERSON_TYPE = [
  { value: "1", name: "Đúng tuyến" },
  { value: "2", name: "Cấp cứu" },
  { value: "3", name: "Trái tuyến" },
  { value: "3.1", name: "Trái tuyến" },
  { value: "3.2", name: "Trái tuyến" },
  { value: "3.3", name: "Trái tuyến" },
  { value: "3.4", name: "Trái tuyến" },
  { value: "3.5", name: "Trái tuyến" },
  { value: "3.6", name: "Trái tuyến" },
  { value: "3.7", name: "Trái tuyến" },
  { value: "4", name: "Thông tuyến" },
  { value: "7", name: "Lĩnh thuốc theo giấy hẹn" },
  { value: "7.1", name: "Lĩnh thuốc theo giấy hẹn" },
  { value: "7.2", name: "Lĩnh thuốc theo giấy hẹn" },
  { value: "7.3", name: "Lĩnh thuốc theo giấy hẹn" },
  { value: "7.4", name: "Lĩnh thuốc theo giấy hẹn" },
  { value: "8", name: "Thu hồi đề nghị thanh toán" },
  { value: "9", name: "Khám bệnh, chữa bệnh dịch vụ" },
];
export const SUBJECT_ON_CARD = [
  {
    value: "DN",
    name: "Người lao động làm việc trong các doanh nghiệp thành lập, hoạt động theo Luật Doanh nghiệp, Luật Đầu tư",
  },
  {
    value: "HX",
    name: "Người lao động làm việc trong các hợp tác xã, liên hiệp hợp tác xã thành lập và hoạt động theo Luật Hợp tác xã",
  },
  {
    value: "CH",
    name: "Người lao động làm việc trong các cơ quan nhà nước, đơn vị sự nghiệp, lực lượng vũ trang, tổ chức chính trị, tổ chức chính trị - xã hội, tổ chức chính trị - xã hội - nghề nghiệp, tổ chức xã hội - nghề nghiệp và tổ chức xã hội khác",
  },
  {
    value: "NN",
    name: "Người lao động làm việc trong các cơ quan, tổ chức nước ngoài hoặc tổ chức quốc tế tại Việt Nam, trừ trường hợp Điều ước quốc tế mà nước Cộng hòa xã hội chủ nghĩa Việt Nam là thành viên tham gia có quy định khác",
  },
  {
    value: "TK",
    name: "Người lao động làm việc trong các tổ chức khác có sử dụng lao động được thành lập và hoạt động theo quy định của pháp luật",
  },
  {
    value: "HC",
    name: "Cán bộ, công chức, viên chức theo quy định của pháp luật về cán bộ, công chức, viên chức",
  },
  {
    value: "XK",
    name: "Người hoạt động không chuyên trách ở xã, phường, thị trấn theo quy định của pháp luật về cán bộ, công chức",
  },
  {
    value: "HT",
    name: "Người hưởng lương hưu, trợ cấp mất sức lao động hàng tháng",
  },
  {
    value: "TB",
    name: "Người đang hưởng trợ cấp bảo hiểm xã hội hàng tháng do bị tai nạn lao động, bệnh nghề nghiệp",
  },
  {
    value: "NO",
    name: "Người lao động nghỉ việc đang hưởng chế độ ốm đau theo quy định của pháp luật về bảo hiểm xã hội do mắc bệnh thuộc danh mục bệnh cần chữa trị dài ngày theo quy định của Bộ trưởng Bộ Y tế",
  },
  {
    value: "CT",
    name: "Người từ đủ 80 tuổi trở lên đang hưởng trợ cấp tuất hàng tháng",
  },
  {
    value: "XB",
    name: "Cán bộ xã, phường, thị trấn đã nghỉ việc đang hưởng trợ cấp bảo hiểm xã hội hàng tháng",
  },
  {
    value: "TN",
    name: "Người đang hưởng trợ cấp thất nghiệp theo quy định của pháp luật về bảo hiểm thất nghiệp",
  },
  {
    value: "CS",
    name: "Công nhân cao su nghỉ việc đang hưởng trợ cấp hàng tháng theo Quyết định 206/CP ngày 30/5/1979 của Hội đồng Chính phủ (nay là Chính phủ) về chính sách đối với công nhân mới giải phóng làm nghề nặng nhọc, có hại sức khỏe nay già yếu phải thôi việc",
  },
  {
    value: "QN",
    name: "Sỹ quan, quân nhân chuyên nghiệp, hạ sỹ quan, binh sỹ Quân đội nhân dân Việt Nam đang tại ngũ; người làm công tác cơ yếu hưởng lương như đối với quân nhân đang công tác tại Ban Cơ yếu Chính phủ; học viên cơ yếu hưởng sinh hoạt phí từ ngân sách Nhà nước theo chế độ, chính sách như đối với học viên Quân đội",
  },
  {
    value: "CA",
    name: "Sỹ quan, hạ sỹ quan nghiệp vụ và sỹ quan, hạ sỹ quan chuyên môn kỹ thuật, hạ sỹ quan, chiến sỹ nghĩa vụ đang công tác trong lực lượng công an nhân dân, học viên công an nhân dân hưởng sinh hoạt phí từ ngân sách Nhà nước",
  },
  {
    value: "CY",
    name: "Người làm công tác cơ yếu hưởng lương như đối với quân nhân đang công tác tại các tổ chức cơ yếu thuộc các Bộ, ngành, địa phương",
  },
  {
    value: "XN",
    name: "Cán bộ xã, phường, thị trấn đã nghỉ việc đang hưởng trợ cấp hàng tháng từ ngân sách Nhà nước",
  },
  {
    value: "MS",
    name: "Người đã thôi hưởng trợ cấp mất sức lao động đang hưởng trợ cấp hàng tháng từ ngân sách Nhà nước",
  },
  {
    value: "CC",
    name: "Người có công với cách mạng, bao gồm: Người hoạt động cách mạng trước ngày 01/01/1945; người hoạt động cách mạng từ ngày 01/01/1945 đến ngày khởi nghĩa tháng 8/1945; Bà mẹ Việt Nam anh hùng; thương binh, người hưởng chính sách như thương binh, thương binh loại B, bệnh binh suy giảm khả năng lao động từ 81% trở lên",
  },
  {
    value: "CK",
    name: "Người có công với cách mạng theo quy định pháp luật về người có công với cách mạng, trừ các đối tượng được cấp mã CC",
  },
  {
    value: "CB",
    name: "Cựu chiến binh theo quy định pháp luật về cựu chiến binh",
  },
  {
    value: "KC",
    name: "Người trực tiếp tham gia kháng chiến chống Mỹ cứu nước; người tham gia chiến tranh bảo vệ Tổ quốc, làm nhiệm vụ quốc tế ở Căm-pu-chia, giúp bạn Lào sau ngày 30/4/1975; thanh niên xung phong thời kỳ kháng chiến chống Pháp và thanh niên xung phong đã hoàn thành nhiệm vụ trong kháng chiến; dân công hỏa tuyến tham gia kháng chiến chống Pháp, chống Mỹ, chiến tranh bảo vệ Tổ quốc và làm nhiệm vụ quốc tế",
  },
  {
    value: "HD",
    name: "Đại biểu Quốc hội, đại biểu Hội đồng nhân dân các cấp đương nhiệm",
  },
  {
    value: "TE",
    name: "Trẻ em dưới 6 tuổi, kể cả trẻ đủ 72 tháng tuổi mà trong năm đó chưa đến kỳ nhập học",
  },
  {
    value: "BT",
    name: "Người thuộc diện hưởng trợ cấp bảo trợ xã hội hàng tháng theo quy định của pháp luật",
  },
  { value: "HN", name: "Người thuộc hộ gia đình nghèo" },
  {
    value: "DT",
    name: "Người dân tộc thiểu số đang sinh sống tại vùng có điều kiện kinh tế - xã hội khó khăn, đặc biệt khó khăn",
  },
  {
    value: "DK",
    name: "Người đang sinh sống tại vùng có điều kiện kinh tế - xã hội đặc biệt khó khăn",
  },
  { value: "XD", name: "Người đang sinh sống tại xã đảo, huyện đảo" },
  {
    value: "TS",
    name: "Thân nhân của người có công với cách mạng là cha đẻ, mẹ đẻ, vợ hoặc chồng, con của liệt sỹ; người có công nuôi dưỡng liệt sỹ",
  },
  {
    value: "TC",
    name: "Thân nhân của người có công với cách mạng, bao gồm: cha đẻ, mẹ đẻ, vợ hoặc chồng, con từ trên 6 tuổi đến dưới 18 tuổi hoặc từ đủ 18 tuổi trở lên nếu còn tiếp tục đi học hoặc bị khuyết tật nặng, khuyết tật",
  },
  { value: "TQ", name: "Thân nhân của đối tượng được cấp mã QN" },
  { value: "TA", name: "Thân nhân của đối tượng được cấp mã CA" },
  { value: "TY", name: "Thân nhân của đối tượng được cấp mã CY" },
  {
    value: "HG",
    name: "Người đã hiến bộ phận cơ thể người theo quy định của pháp luật",
  },
  {
    value: "LS",
    name: "Người nước ngoài đang học tập tại Việt Nam được cấp học bổng từ ngân sách của Nhà nước Việt Nam",
  },
  {
    value: "PV",
    name: "Người phục vụ người có công với cách mạng, bao gồm: người phục vụ Bà mẹ Việt Nam anh hùng sống ở gia đình; người phục vụ thương binh, bệnh binh suy giảm khả năng lao động từ 81% trở lên ở gia đình; người phục vụ người hoạt động kháng chiến bị nhiễm chất độc hóa học suy giảm khả năng lao động từ 81% trở lên sống ở gia đình",
  },
  { value: "CN", name: "Người thuộc hộ gia đình cận nghèo" },
  {
    value: "HS",
    name: "Học sinh đang theo học tại các cơ sở giáo dục và đào tạo thuộc hệ thống giáo dục quốc dân",
  },
  {
    value: "SV",
    name: "Sinh viên đang theo học tại các cơ sở giáo dục và đào tạo, cơ sở dạy nghề thuộc hệ thống giáo dục quốc dân",
  },
  {
    value: "GB",
    name: "Người thuộc hộ gia đình làm nông nghiệp, lâm nghiệp, ngư nghiệp và diêm nghiệp có mức sống trung bình theo quy định của pháp luật",
  },
  {
    value: "GD",
    name: "Người tham gia BHYT theo hộ gia đình gồm những người thuộc hộ gia đình, trừ đối tượng quy định tại các mục nêu trên",
  },
];

export const REFERRAL_REQUEST_TYPE = [
  { value: 1, name: "Nhập viện" },
  { value: 2, name: "Ra viện" },
  { value: 3, name: "Chuyển viện" },
  { value: 4, name: "Chuyển khoa" },
  { value: 5, name: "Chuyển đến phòng phẫu thuật" },
  { value: 6, name: "Chuyển tuyến" },
  { value: 7, name: "Chuyển chuyên khoa" },
  { value: 8, name: "Chuyển khám" },
];
export const REFERRAL_REQUEST_TYPE_PRINT = [
  { value: 1, name: "GIẤY NHẬP VIỆN" },
  { value: 2, name: "GIẤY RA VIỆN" },
  { value: 3, name: "GIẤY CHUYỂN VIỆN" },
  { value: 4, name: "GIẤY CHUYỂN KHOA/PHÒNG" },
];

export const RECEIVING_STATUS = [
  { value: 1, name: "Chưa tiếp nhận" },
  { value: 2, name: "Đã tiếp nhận" },
];

export const RECEIVED = 2;
export const NOT_RECEIVED = 1;
export const PATIENT_FINISHED = 4;
export const EPISODE_OF_CARE_STATUS_END = 2;
export const EPISODE_OF_CARE_STATUS_BEING_TREATMENT = 1;

export const EPISODE_OF_CARE_STATUS = [
  {
    name: "Đã kết thúc",
    value: "2",
    color: "#fff",
    bgColor: "green",
    icon: <HowToReg style={{ color: "green" }} />,
  },
  {
    name: "Duyệt ra viện",
    value: "3",
    color: "#fff",
    bgColor: "#ff0000",
    icon: <HowToReg style={{ color: "#ff0000" }} />,
  },
  {
    name: "Đang điều trị",
    value: "1",
    color: "#fff",
    bgColor: "#ff8100",
    icon: <AccountBox style={{ color: "#ff8100" }} />,
  },
  {
    name: "Mới",
    value: "0",
    color: "#fff",
    bgColor: "#0076ff",
    icon: <AccountCircle style={{ color: "#0076ff" }} />,
  },
];

export const INVOICE_TYPE_BY_ITEMS = {
  SERVICE: 1,
  MEDICALSUPPLY: 2,
  MEDICATION: 3,
};

export const DRUG_ORDER_SOURCE_TYPE = [
  { value: 1, name: "Bảo hiểm" },
  { value: 2, name: "Dịch vụ" },
  { value: 3, name: "Tự túc" },
];
export const SURGERY_STATUS = [
  { name: "Chờ phẫu thuật", value: 1 },
  { name: "Đang phẫu thuật", value: 2 },
  { name: "Đã phẫu thuật - chờ hồi phục", value: 3 },
  { name: "Đã phẫu thuật - tiếp tục điều trị", value: 4 },
];
export const COEFFICIENT = [
  { name: "Phiếu thu", value: 1 },
  { name: "Phiếu chi", value: -1 },
];

export const ReportOrderType = [
  { name: "Theo Bệnh Nhân", value: 1 },
  { name: "Theo ngày hóa đơn", value: 2 },
];

export const Counselor = 7;
export const COUNSELOR_CODE = "counselor";
export const ROLE = [
  { name: "Mổ chính", value: 2 },
  { name: "Phụ mổ", value: 3 },
  { name: "Kỹ thuật viên", value: 4 },
  { name: "Bác sĩ gây mê - hồi sức", value: 5 },
  { name: "Nhân viên tư vấn", value: Counselor },
];

export const ENCOUNTER_END = 3;
export const ENCOUNTER_NEW = 0;
export const ENCOUNTER_DOING = 2;

export const ENCOUNTER_STATUS = [
  {
    name: "Mới",
    value: ENCOUNTER_NEW,
    icon: <AccountCircle style={{ color: "#0076ff" }} />,
  },
  {
    name: "Đang khám",
    value: ENCOUNTER_DOING,
    icon: <AccountBox style={{ color: "#ff8100" }} />,
  },
  {
    name: "Đã kết thúc",
    value: ENCOUNTER_END,
    icon: <HowToReg style={{ color: "green" }} />,
  },
];

export const STATUS = [
  { name: "Đã trả", value: 1 },
  { name: "Đang giữ", value: 2 },
];

export const INTERNAL_VISIT_TYPE = "in_patient";
export const OUTERNAL_VISIT_TYPE = "out_patient";
export const EMERGENCY = "emergency";
export const phoneRegExp =
  /((^(84|0){1})(2|3|5|7|8|9))+([0-9]{8})$|((^(01|02){1}))+([0-9]{9})$/;

export const USE_INSURANCE_TYPE = [
  { name: "Có thanh toán BHYT", value: 1 },
  { name: "Không thanh toán BHYT", value: 2 },
];

export const LIST_WAGE_TYPE = [
  { name: "Phần trăm", value: 1 },
  { name: "Cố định", value: 2 },
];
export const PRODUCT_TYPE_DRUG = 1;
export const PRODUCT_TYPE_SUPPLY = 2;
//loại hàng hóa
export const PRODUCT_TYPE = [
  { name: "Thuốc", value: PRODUCT_TYPE_DRUG },
  { name: "Vật tư", value: PRODUCT_TYPE_SUPPLY },
  { name: "Đơn vị tính", value: 3 },
  { name: "Khoa phòng", value: 4 },
];

export const SEARCH_BY = [
  { name: "Ngày chỉ định dịch vụ", value: 1 },
  { name: "Ngày thực hiện dịch vụ", value: 2 },
  // { name: 'Đơn vị tính', value: 3 },
  // { name: '', value: 3 },
];

// store request
export const STORE_REQUEST_STATUS = [
  { name: "Từ chối yêu cầu", value: -1, color: "#ff0000" },
  { name: "Mới", value: 0, color: "#f7ba61" },
  { name: "Đã chuẩn bị", value: 1, color: "#2acaea" },
  { name: "Đã hoàn thành", value: 2, color: "#008000" },
  { name: "Đã cấp phát", value: 3, color: "#008000" },
];

export const PRO_TYPE = [
  { name: "Thuốc", value: 1 },
  { name: "Vật tư", value: 2 },
];

export const ADMIN_USERNAME = "admin";

export const HOSPITAL_NAME = ORG_NAME;

export const HEALTH_SERVICE_DEPT = "Sở y tế Bình Thuận";
export const HOSPITAL_LOCATION = "Bình Thuận";
export const HOSPITAL_PHONE = "Bình Thuận";

export const QR_TYPE = [
  { name: "CCCD", value: 1 },
  { name: "BHYT", value: 2 },
  { name: "Mã Bệnh nhân", value: 3 },
];

export const LIST_DOCUMENT_TYPE = [
  { name: "BHYT", value: 1 },
  { name: "Dịch vụ", value: 2 },
  { name: "Khác", value: 3 },
];

export const GEN_QR_TYPE_GLASSES = 1;
export const GEN_QR_TYPE_MEDICINE = 2;
export const GEN_QR_TYPE = [
  { name: "Đơn kính", value: GEN_QR_TYPE_GLASSES },
  { name: "Đơn thuốc", value: GEN_QR_TYPE_MEDICINE },
  { name: "Phiếu đăng ký khám", value: 3 },
];

export const EPI_TYPE = [
  { name: "Ngoại trú", value: OUTERNAL_VISIT_TYPE },
  { name: "Nội trú", value: INTERNAL_VISIT_TYPE },
];
export const REGULAR_HEALTH_CHECK = "regular_health_check";
export const VISIT_TYPE = [
  { name: "Ngoại trú", value: "out_patient" },
  { name: "Nội trú", value: "in_patient" },
  { name: "Khám lần đầu", value: "first_examination" },
  { name: "Khám sức khỏe định kỳ", value: REGULAR_HEALTH_CHECK },
];

export const TypeSearchInvoice = {
  TYPE_TREATMENT: 1,
  EPISODE_OF_CARD: 2,
  VISIT: 3,
};

export const TypeTreatment = {
  BOARDING: 1,
  OPC: 2,
};

export const HICS_TYPE = [
  { name: "KHÁM BỆNH", value: 1 },
  { name: "ĐIỀU TRỊ NGOẠI TRÚ", value: 2 },
  { name: "ĐIỀU TRỊ NỘI TRÚ", value: 3 },
  { name: "ĐIỀU TRỊ BAN NGÀY", value: 4 },
];

export const LIST_GENDER_HIC = [
  { name: "Nam", value: 1 },
  { name: "Nữ", value: 2 },
  { name: "Chưa xác định", value: 3 },
];
export const EPISODE_OF_CARE_TYPE_OUTPATIENT = 1;
export const EPISODE_OF_CARE_TYPE = [
  { name: "Nội trú", value: 2 },
  { name: "Ngoại trú", value: 1 },
  { name: "Nội trú ban ngày", value: 3 },
];

export const MEDICATION_REQUEST_TYPE_INSURANCE = 1;
export const MEDICATION_REQUEST_TYPE_SERVICE = 2;
export const MEDICATION_REQUEST_TYPE_OTHER = 5;
export const MEDICATION_REQUEST_TYPE_CATEGORY = 6;
export const MEDICATION_REQUEST_TYPE = [
  { name: "Bảo hiểm", value: MEDICATION_REQUEST_TYPE_INSURANCE },
  { name: "Dịch vụ", value: MEDICATION_REQUEST_TYPE_SERVICE },
  { name: "Tư vấn", value: MEDICATION_REQUEST_TYPE_OTHER },
];

export const MEDICATION_REQUEST_TYPE_ABBREVIATION = [
  //viet tat
  { name: "BH", value: MEDICATION_REQUEST_TYPE_INSURANCE },
  { name: "DV", value: MEDICATION_REQUEST_TYPE_SERVICE },
  { name: "TV", value: MEDICATION_REQUEST_TYPE_OTHER },
];

export const ANESTHESIA_METHOD = [
  { name: "Gây mê", value: 1 },
  { name: "Gây tê", value: 2 },
  { name: "Châm tê", value: 3 },
  { name: "Khác", value: 4 },
];

export const PAYMENT_SOURCE = [
  { name: "Quỹ BHYT chi trả", value: 1 },
  { name: "Thuốc của dự án hoặc viện trợ", value: 2 },
  { name: "Thuốc thuộc CT mục tiêu Quốc gia", value: 3 },
  { name: "Các nguồn chi trả khác", value: 4 },
];
export const STATUS_SEND_HI_PORT_NOT_SEND = 1;
export const STATUS_SEND_HI_PORT = [
  { name: "Đã gửi thành công", value: 3, color: "green" },
  { name: "Đã gửi nhưng bị từ chối", value: 2, color: "orange" },
  { name: "Chưa gửi", value: STATUS_SEND_HI_PORT_NOT_SEND, color: "red" },
];

export const STATUS_SEND_MEDI_REQUEST = [
  { name: "Chưa gửi yêu cầu xuất kho", value: 1 },
  { name: "Đã gửi yêu cầu nhưng bệnh nhân chưa lĩnh", value: 2 },
  { name: "Bệnh nhân đã nhận thuốc", value: 3 },
];

export const VISIT_RESULT = [
  { name: "Khỏi", value: 1 },
  { name: "Đỡ ", value: 2 },
  { name: "Không thay đổi", value: 3 },
  { name: "Nặng hơn", value: 4 },
  { name: "Tử vong ", value: 5 },
  { name: "Tiên lượng nặng xin về", value: 6 },
  {
    name: "Chưa xác định (không thuộc một trong các mã kết quả điều trị nêu trên)",
    value: 7,
  },
];

export const TREATMENT_RESULT = [
  { name: "Khỏi", value: 1 },
  { name: "Đỡ, giảm ", value: 2 },
  { name: "Không thay đổi", value: 3 },
  { name: "Nặng hơn", value: 4 },
  { name: "Tử vong", value: 5 },
  { name: "Tiên lượng nặng xin về", value: 6 },
  { name: "Chưa xác định", value: 7 },
  { name: "Tử vọng nội viện", value: 8 },
  { name: "Tử vọng ngoại viện", value: 9 },
  { name: "Thẻ hết hạn", value: 10 },
];

export const SEND_TO_HI_PORT_TYPE_EXAM_STATUS = 1;
export const SEND_TO_HI_PORT_TYPE_PAYMENT_REQUEST = 2;

export const SEND_TO_HI_PORT_TYPE = [
  { name: "Trạng thái KCB", value: 1 },
  { name: "Yêu cầu thanh toán ", value: 2 },
];

export const AREA_CODE = [
  { name: "K1", value: "K1", areaCodeCard: "5" },
  { name: "K2", value: "K2", areaCodeCard: "6" },
  { name: "K3", value: "K3", areaCodeCard: "7" },
];

export const EXAMINATION_TYPE_RECEPTION = "Reception";

export const EXAMINATION_TYPE_EXAM = "examination";

export const EXAMINATION_TYPE = [
  { name: "Đo khúc xạ", value: "Vefraction_measurement" },
  { name: "Đo kính", value: "Glasse_measuring" },
  { name: "Tiếp đón", value: "Reception" },
  { name: "Khám", value: "examination" },
  { name: "Xét nghiệm", value: "LabTest" },
  { name: "Thủ thuật", value: "Procedures" },
  { name: "Chẩn đoán bằng hình ảnh", value: "Diagnostic_imaging" },
  { name: "Phẫu thuật", value: "Surgery" },
  { name: "Khám nội", value: "internal_examination" },
  { name: "Dịch vụ giường", value: "BedProvided" },
  { name: "Cung cấp các dịch vụ y tế khác", value: "orther_service_provided" },
];

export const PERFORM_ON = [
  { name: "Mắt phải", value: 1 },
  { name: "Mắt trái", value: 2 },
  { name: "Cả 2 mắt", value: 3 },
];

export const CODE_HI_BENEFITS = [
  //mã mức hưởng
  { name: "100%", value: 100, codeInCard: "1" },
  { name: "100%", value: 100, codeInCard: "2" },
  { name: "95%", value: 95, codeInCard: "3" },
  { name: "80%", value: 80, codeInCard: "4" },
  { name: "100%", value: 100, codeInCard: "5" },
];

export const HI_BENEFITS = [
  //mức hưởng
  { name: "100%", value: 100 },
  { name: "95%", value: 95 },
  { name: "80%", value: 80 },
];

export const PAYMENT_METHOD = [
  { name: "Tiền mặt", value: 1 },
  { name: "Chuyển khoản ngân hàng", value: 2 },
  { name: "Quẹt thẻ", value: 3 },
  { name: "Công nợ bảo lãnh", value: 4 },
  { name: "Công nợ khách hàng", value: 5 },
  { name: "Khác", value: 6 },
];

export const PaymentMethodGuaranteedDebt = 4;
export const PaymentMethodAccountsReceivable = 5;

export const PAYMENT_METHOD_DEBT = [
  { name: "Công nợ bảo lãnh", value: PaymentMethodGuaranteedDebt },
  { name: "Công nợ khách hàng", value: PaymentMethodAccountsReceivable },
];

export const PAYMENT_REQUIRED_TYPE = [
  { name: "Thanh toán hết phí", value: 1 },
  { name: "Thanh toán một phần", value: 2 },
  { name: "Không kiểm tra thanh toán", value: 3 },
];

export const PAYMENT_SOURCE_PATIENT_PAID = 0;
export const PAYMENT_SOURCE_HI_PAID = 1;
export const PAYMENT_SOURCE_HOSPITAL_PAID = 3;
export const PAYMENT_SOURCE_OTHER_PAID = 2;

export const IS_EXPORTED = [
  { name: "Đã cấp phát", value: 1 },
  { name: "Chưa cấp phát", value: 2 },
];

export const REQUEST_NUMBER_STATUS = [
  { name: "Chưa phục vụ", value: 1 },
  { name: "Đã qua lượt", value: 2 },
  { name: "Đã phục vụ", value: 3 },
];

export const ULTRASOUND_ROOM_CODE = "PHONG_SIEU_AM";
export const PROCEDURE_ROOM_CODE = "PHONG_THU_THUAT";
export const EXAM_ROOM_CODE = "PHONG_SANG_LOC";

export const LIST_ROOM = [
  { name: "Phòng siêu âm", value: ULTRASOUND_ROOM_CODE },
  { name: "Phòng khám phụ khoa", value: PROCEDURE_ROOM_CODE },
  { name: "Phòng khám bệnh", value: EXAM_ROOM_CODE },
];
export const PATIENT_TYPE = [
  { name: "Ưu tiên", value: "1" },
  { name: "Không ưu tiên", value: "0" },
];

export const MATERNITY_SERVICE = [
  { name: "Siêu âm thai nhỏ", value: "SATN" },
  { name: "Siêu âm thai", value: "SAT" },
  { name: "Siêu âm 4D", value: "SIEUAM4D" },
  { name: "Siêu âm 2D", value: "SA2D" },
];

export const REQUEST_NUM_STATUS = [
  { name: "Đã đặt lịch, chờ xác nhận", value: 1 },
  { name: "Đã xác nhận, chưa đến khám", value: 2 },
  { name: "Đã đăng ký khám và nộp tiền, chờ khám", value: 3 },
  { name: "Đã khám", value: 4 },
];

export const REQUEST_NUM_TYPE_PRIORYTY = 1;
export const REQUEST_NUM_TYPE_NORMAL = "0";
export const REQUEST_NUM_TYPE = [
  { name: "Ưu tiên", value: REQUEST_NUM_TYPE_PRIORYTY },
  { name: "Thường", value: REQUEST_NUM_TYPE_NORMAL },
];

export const REQUEST_NUM_TYPE_HEALTH_NUMBER = 1;
export const REQUEST_NUM_TYPE_NOT_HEALTH_NUMBER = 0;
export const REQUEST_NUM_HEALTH_NUMBER = [
  { name: "Có thẻ BHYT", value: REQUEST_NUM_TYPE_HEALTH_NUMBER },
  { name: "Không có thẻ BHYT", value: REQUEST_NUM_TYPE_NOT_HEALTH_NUMBER },
];

export const TYPE_CONFIRM_REQUEST_NUMBER = [
  { name: "Đã đặt lịch, chờ xác nhận", value: 1 },
  { name: "Đã xác nhận, chưa đến khám", value: 2 },
  { name: "Hủy lịch hẹn", value: 3 },
  { name: "Đã đăng ký khám", value: 4 },
  { name: "Đang khám", value: 5 },
  { name: "Đã kết thúc", value: 6 },
];

export const SolutionVisit = {
  HOSPITAL: 1,
  ROOMTRANSFER: 2,
  OPERATINGROOMTRANSFER: 3,
  HOSPITALDISCHARGE: 4,
  TRANSIT: 5,
  PROCEDURE: 6,
  DEAD: 7,
  PRESCRIPTIONDISCHARGE: 8,
  PRESCRIPTIONAPPOINTMENT: 9,
  NOPRESCRIPTION: 10,
  TRANSFEREXAM: 14,
  ESCAPEHOSPITAL: 15,
  NOEXAMINATION: 16,
};

export const SOLUTION_DEFAULT = [
  { name: "Không toa", value: SolutionVisit.NOPRESCRIPTION },
  { name: "Cấp toa và cho về", value: SolutionVisit.PRESCRIPTIONDISCHARGE },
  {
    name: "Cấp toa và hẹn tái khám",
    value: SolutionVisit.PRESCRIPTIONAPPOINTMENT,
  },
  { name: "Nhập viện", value: SolutionVisit.HOSPITAL },
  { name: "Chuyển khám", value: SolutionVisit.TRANSFEREXAM },
  { name: "Chuyển viện", value: SolutionVisit.TRANSIT },
  { name: "Tử vong", value: SolutionVisit.DEAD },
  { name: "Hội chẩn", value: 11 },
  { name: "Trốn viện", value: SolutionVisit.ESCAPEHOSPITAL },
  { name: "Không khám", value: SolutionVisit.NOEXAMINATION },
];

export const SECONDARY_SOLUTION = [
  { name: "Cấp toa cho về", value: SolutionVisit.PRESCRIPTIONDISCHARGE },
  {
    name: "Cấp toa và hẹn tái khám",
    value: SolutionVisit.PRESCRIPTIONAPPOINTMENT,
  },
  { name: "Không toa", value: 10 },
  { name: "Chuyển khám", value: SolutionVisit.TRANSFEREXAM },
];

export const VOUCHER_INVOICE_TYPE_VALUE = {
  Finalization: "Finalization",
  Advance: "Advance",
  Refund: "Refund",
  Receipt: "Receipt",
  DebtCollection: "DebtCollection",
};

export const VOUCHER_TYPE_VALUE = {
  Paid: -1,
  Receive: 1,
};

export const VOUCHER_INVOICE_TYPE = [
  { name: "Quyết toán", value: VOUCHER_INVOICE_TYPE_VALUE.Finalization },
  { name: "Tạm ứng", value: VOUCHER_INVOICE_TYPE_VALUE.Advance },
  { name: "Hoàn tiền", value: VOUCHER_INVOICE_TYPE_VALUE.Refund },
  { name: "Thu tiền", value: VOUCHER_INVOICE_TYPE_VALUE.Receipt },
  { name: "Công nợ", value: VOUCHER_INVOICE_TYPE_VALUE.DebtCollection },
];

export const VOUCHER_INVOICE_TYPE_REPORT_DETAIL = [
  { name: "Tạm ứng", value: VOUCHER_INVOICE_TYPE_VALUE.Advance },
  { name: "Hoàn tiền", value: VOUCHER_INVOICE_TYPE_VALUE.Refund },
  { name: "Thu tiền", value: VOUCHER_INVOICE_TYPE_VALUE.Receipt },
];

export const VOUCHER_STATUS_VALUE = {
  New: 0,
  Active: 1,
  Cancel: -1,
};

export const VOUCHER_STATUS = [
  {
    name: "Mới - Chưa có hiệu lực",
    value: VOUCHER_STATUS_VALUE.New,
    className: "voucher-status-new",
    icon: <Brightness1 style={{ color: "#fbedc1" }} />,
  },
  {
    name: "Đã có hiệu lực",
    value: VOUCHER_STATUS_VALUE.Active,

    className: "voucher-status-active",
    icon: <Brightness1 style={{ color: "#00e0ff" }} />,
  },
  {
    name: "Đã hủy - Không có hiệu lực",
    value: VOUCHER_STATUS_VALUE.Cancel,

    className: "voucher-status-cancel",
    icon: <Brightness1 style={{ color: "#ff8100" }} />,
  },
];

export const STAFF_REVENUE_STATUS = [
  {
    name: "Phân bổ cũ",
    className: "voucher-status-new",
    icon: <Brightness1 style={{ color: "#ffeeba" }} />,
  },
  {
    name: "Phân bổ mới",
    className: "voucher-status-active",
    icon: <Brightness1 style={{ color: "#e6f7ff " }} />,
  },
];

export const SERVICE_REQUEST_ITEM_STATUS = [
  { name: "Mới", value: 0 },
  { name: "Đang thực hiện", value: 2 },
  { name: "Đã có kết quả", value: 3 },
];

export const DEPARTMENT_TYPE_FUNCTIONAL = 2;
export const DEPARTMENT_TYPE_EXAM = 1;

export const DEPARTMENT_TYPE = [
  { name: "Khoa khám/điều trị", value: DEPARTMENT_TYPE_EXAM },
  { name: "Khoa chức năng", value: DEPARTMENT_TYPE_FUNCTIONAL },
];

export const LIST_TRANSPORTATION = [
  { value: 1, name: "Tự túc" },
  { value: 2, name: "Ô tô cứu thương có hộ tống" },
];

export const DRUG_TYPE = [
  { name: "Điều trị", value: 1 },
  { name: "Dự phòng", value: 2 },
];

export const MEDICATION_STATUS_STOCK_OUT = [
  { name: "Chưa lĩnh thuốc", value: 1 },
  { name: "Mới lĩnh thuốc", value: 2 },
  { name: "Đã sử dụng thuốc", value: 3 },
  { name: "Đã hoàn trả thuốc", value: 4 },
  { name: "Đã phát hết thuốc", value: 5 },
  { name: "Chưa lĩnh hết thuốc", value: 6 },
];

export const VisitPersonType = {
  HEALTH_INSURANCE: 1,
  NOT_HEALTH_INSURANCE: 2,
  SERVICE: 3,
};

export const VISIT_PERSON_TYPE = [
  { name: "BHYT", value: VisitPersonType.HEALTH_INSURANCE },
  { name: "Viện phí", value: VisitPersonType.NOT_HEALTH_INSURANCE },
  { name: "Dịch vụ", value: VisitPersonType.SERVICE },
];

export const BIDDING_TYPE = [
  { name: "BHYT", value: "1" },
  { name: "Tự mua sắm", value: "0" },
  { name: "Hỗn hợp", value: "2" },
];
export const BIDDING_PACKAGE_TYPE = [
  { name: "BHYT", value: "1" },
  { name: "Ngoài BHYT", value: "0" },
];

export const StoreType = {
  OUTPATIENT_STORE: 1,
  INPATIENT_STORE: 2,
};

export const LIST_STORE_TYPE = [
  { name: "Ngoại trú", value: StoreType.OUTPATIENT_STORE },
  { name: "Nội trú", value: StoreType.INPATIENT_STORE },
];

export const REGISTER_FORM = [
  { name: "Tự đến", value: 1 },
  { name: "Giấy chuyển tuyến", value: 2 },
  { name: "Giấy hẹn", value: 3 },
  { name: "Giấy XN cấp cứu", value: 4 },
];

export const ARRIVE_FORM = [
  { name: "Thẻ BHYT", value: 1 },
  { name: "VSSID", value: 2 },
  { name: "CCCD", value: 3 },
];

export const DRUG_INTERACTION_TYPE = [
  { name: "Tương tác", value: 1 },
  { name: "Tương kỵ", value: 2 },
];

export const FORM_OF_DEATH = [
  { name: "Bệnh", value: 1 },
  { name: "Bị tấn công", value: 2 },
  { name: "Không thể xác định", value: 3 },
  { name: "Tai nạn", value: 4 },
  { name: "Liên quan đến pháp luật", value: 5 },
  { name: "Chờ điều tra", value: 6 },
  { name: "Cố ý làm hại bản thân", value: 7 },
  { name: "Chiến tranh", value: 8 },
  { name: "Không có thông tin", value: 9 },
];

export const PLACE_OF_DEATH = [
  { name: "Tại nhà", value: 1 },
  { name: "Khu dân cư", value: 2 },
  { name: "Trường học, khu hành chính khác", value: 3 },
  { name: "Khu thể thao", value: 4 },
  { name: "Trên đường đi", value: 5 },
  { name: "Khu thương mại và dịch vụ", value: 6 },
  { name: "Khu công nghiệp", value: 7 },
  { name: "Nông trại", value: 8 },
  { name: "Địa điểm khác", value: 9 },
  { name: "Không biết", value: 10 },
];

export const YES_NO = [
  { name: "Có", value: 1 },
  { name: "Không", value: 2 },
  { name: "Không rõ", value: -1 },
];

export const DECEASE_WAS_PREGNANT = [
  { name: "Có", value: 1 },
  { name: "Không", value: 2 },
  { name: "Không biết", value: -1 },
  { name: "Tại thời điểm tử vong", value: 3 },
  { name: "Trong vòng 42 ngày trước khi tử vong", value: 4 },
  { name: "Từ 43 ngày đến 1 năm trước khi chết", value: 5 },
];

export const WORK_AROUND = [
  { name: "Chuyển phòng", value: 1 },
  { name: "Cấp toa cho về", value: 2 },
  { name: "Cấp toa và hẹn tái khám", value: 3 },
  { name: "Chuyển tuyến", value: 4 },
  { name: "Nhập viện", value: 5 },
  { name: "Không toa", value: 6 },
  { name: "Hội chẩn", value: 7 },
  { name: "Xuất mẫu số C65-HD2", value: 8 },
  { name: "Điều trị bệnh án ngoại trú", value: 9 },
];
export const TYPE_OF_CONSULTATION = [
  { name: "Trong khoa", value: 1 },
  { name: "Liên khoa", value: 2 },
  { name: "Trong bệnh viện", value: 3 },
  { name: "Liên bệnh viện", value: 4 },
];
export const LIST_CONSULTATION_MEMBER_ROLE = [
  { name: "Chủ tọa", value: 1 },
  { name: "Thư kí", value: 2 },
  { name: "Thành viên", value: 3 },
];
export const ALERT_TYPE = [
  { name: "Cho phép kê", value: 1 },
  { name: "Không được phép kê", value: 2 },
  { name: "Cảnh báo", value: 3 },
];
export const BOUNDARY_OPTIONS = [
  { name: "Chỉ lấy cận dưới (≤ x <)", value: 1 },
  { name: "Chỉ lấy cận trên (< x ≤)", value: 2 },
  { name: "Lấy cả 2 cận (≤ x ≤)", value: 3 },
  { name: "Không lấy 2 cận (< x <)", value: 4 },
];

export const TYPE_OF_EXAM = {
  MAIN_EXAM: 1,
  SUB_EXAM: 2,
};

export const WORKING_SLOT_STATUS = {
  AVAILABLE: 0,
  OCCUPIED: 1,
};

export const STATUS_WORKING_SLOT = [
  { name: "Trống", value: 0 },
  { name: "Đã đặt lịch", value: 1 },
];

export const PATIENT_HOSPITAL_BED_STATUS = [
  { name: "Đang nằm", value: 1 },
  { name: "Đã kết thúc", value: 2 },
];

export const REASON_FOR_TRANSFER = [
  { name: "Bệnh nhân đề nghị", value: 1 },
  { name: "Bác sĩ đề nghị", value: 2 },
  { name: "Nhầm giường", value: 3 },
];

export const MEDICAL_RECORD_CATEGORY = [
  // { name: "Bệnh án phụ khoa", value: 1 },
  { name: "Bệnh án phụ khoa", value: 1 },
  { name: "Bệnh án sản khoa", value: 2 },
  { name: "Bệnh án sơ sinh", value: 3 },
  { name: "Bệnh án truyền nhiễm", value: 4 },
  { name: "Bệnh án YHCT (ĐT ngoại trú)", value: 5 },
  { name: "Bệnh án Răng hàm mặt (Ngoại trú)", value: 6 },
  { name: "Bệnh án Tai mũi họng (Ngoại trú)", value: 7 },
];

export const DRUG_TYPES = [
  { name: "Thuốc", value: 1 },
  { name: "Thực phẩm chức năng", value: 2 },
  { name: "Thuốc (*)", value: 3 },
  { name: "Thuốc duyệt lãnh đạo", value: 4 },
];
export const StatusStoreRequest = {
  REJECT: -1,
  NEW: 0,
  CONFIRM: 1,
  COMPLETE: 2,
};
export const LIST_STATUS_STORE_REQUEST = [
  { value: StatusStoreRequest.REJECT, name: "Từ chối" },
  { value: StatusStoreRequest.NEW, name: "Mới" },
  { value: StatusStoreRequest.CONFIRM, name: "Đã chuẩn bị" },
  { value: StatusStoreRequest.COMPLETE, name: "Đã hoàn thành" },
];

export const LIST_CARE_MODE = [
  { value: "1", name: "Cấp I" },
  { value: "2", name: "Cấp II" },
  { value: "3", name: "Cấp III" },
];

export const TYPE_CONSULTATION = [
  { value: 1, name: "Liên khoa" },
  { value: 2, name: "Toàn bệnh viện" },
  { value: 3, name: "Liên bệnh viện" },
];
export const KIND_OF_CONSULTATION = [
  { value: 1, name: "HC thuốc (*)" },
  { value: 2, name: "HC thuốc lãnh đạo" },
  { value: 3, name: "HC bệnh" },
];
export const KIND_CONSULTATION = [
  { value: 1, name: "HC thuốc (*)" },
  { value: 2, name: "HC thuốc lãnh đạo" },
];
export const CONSULTATION_STATUS = [
  { value: 1, name: "Chưa yêu cầu hội chẩn" },
  { value: 2, name: "Chờ hội chẩn" },
  { value: 3, name: "Đã hội chẩn" },
];

export const TREATMENT_OUTCOME = [
  { value: 1, name: "Khỏi" },
  { value: 2, name: "Giảm" },
  { value: 3, name: "Không thay đổi" },
  { value: 4, name: "Nặng xin về" },
  { value: 5, name: "Tử vong" },
  { value: 6, name: "Nặng hơn" },
];

export const REFERRAL = [
  { value: 1, name: "Chuyển người bệnh từ tuyến dưới lên tuyến trên liền kề" },
  {
    value: 2,
    name: "Chuyển người bệnh từ tuyến dưới lên tuyến trên không qua tuyến liền kề",
  },
  { value: 3, name: "Chuyển người bệnh từ tuyến trên xuống tuyến dưới" },
  {
    value: 4,
    name: "Chuyển người bệnh giữa các cơ sở khám bệnh, chữa bệnh trong cùng tuyến",
  },
  {
    value: 5,
    name: "Tuyến trên chuyển về cơ sở kkcd nơi gửi người bệnh để tiếp tục điều trị",
  },
];

export const TREATMENT_DIRECTION = [
  { value: 2, name: "Ra viện" },
  { value: 3, name: "Chuyển viện" },
  { value: 10, name: "Tử vong" },
];

export const TYPE_MEDICATION_ALERT = [
  { value: 1, name: "Dị ứng thuốc" },
  { value: 2, name: "Tương tác thuốc" },
  { value: 3, name: "Trùng thuốc" },
  { value: 4, name: "Trùng nhóm điều trị" },
  { value: 5, name: "Tương kị thuốc" },
];

export const newMedicalRecordStatus = 1;
export const enteredMedicalRecordStatus = 2;
export const summarizedMedicalRecordStatus = 3;

export const MEDICAL_RECORD_STATUS = [
  { value: newMedicalRecordStatus, name: "Mới tạo" },
  { value: enteredMedicalRecordStatus, name: "Đã nhập" },
  { value: summarizedMedicalRecordStatus, name: "Đã tổng kết" },
];

export const SPEED_UNIT = [{ value: "Giọt/Phút", name: "Giọt/Phút" }];

export const INFUSION_TYPE = [
  { name: "Không cần pha chế", value: 1 },
  { name: "Bắt buộc pha chế", value: 2 },
  { name: "Có thể pha chế", value: 3 },
];

export const TYPE_FOMULA = [
  { name: "Dịch truyền", value: 1 },
  { name: "Kháng sinh", value: 2 },
];

export const INFUSION_STATUS = [
  { name: "Mới tạo", value: 1 },
  { name: "Đang truyền", value: 2 },
  { name: "Đã truyền xong", value: 3 },
];

export const TYPE_SEARCH = [
  { name: "Ngày tạo", value: 1 },
  { name: "Ngày bắt đầu", value: 2 },
  { name: "Ngày kết thúc", value: 3 },
];

export const DRUG_REFUND_STATUS = [
  { name: "Đã yêu cầu hoàn trả", value: 1 },
  { name: "Kho từ chối hoàn trả", value: 2 },
  { name: "Đã được hoàn trả", value: 3 },
];

export const CUSTOMERTYPES = [
  { name: "ALL ", value: 1 },
  { name: "VIP", value: 2 },
];

export const OPTIONTYPES = [
  { name: "Trong gói chung của đoàn ", value: 1 },
  { name: "Dịch vụ tự chọn trong gói chung của đoàn", value: 2 },
  { name: "Dịch vụ yêu cầu ngoài gói đề xuất", value: 3 },
];

export const ListScreen = {
  OUT_PATIENT_PATIENT_INFO: "out-patient-patient-info", //tab thông tin cơ bản khám ngoại trú
  IN_PATIENT_PATIENT_INFO: "in-patient-patient-info", //tab thông tin cơ bản khám ngoại trú

  TREARMENT_REGIMEN: "treatment-regimen", //tờ điều trị
  OUTERNAL_EXAM: "outernal-exam", // Thăm khám ở khám ngoại trú
  PATIENT_RECEPTION_ROOM: "patient-reception-room", // Tiếp đón
  PATIENT_BOARDING_LIST: "patient-boarding-list", // Danh sách bệnh nhân ngoại trú
  SURGICAL_PROCEDURE: "surgical-procedure", // Danh sách phẫu thuật thủ thuật
  HOSPITAL_FEE: "hospital-fee", // Danh sách phẫu thuật thủ thuật
  DIAGNOSTIC_IMAGING: "diagnostic-imaging", //Module Chẩn đoán HA
  GROUP_MEDICAL_EXAM: "group-medical-exam", //kham doan
};

export const LIST_FIELD_BY_SCREEN = [
  {
    screen: ListScreen.OUTERNAL_EXAM,
    name: "Khám toàn thân",
    fieldCode: "fullBodyExamination",
  },
  {
    screen: ListScreen.OUTERNAL_EXAM,
    name: "Khám bộ phận",
    fieldCode: "partExamination",
  },
  {
    screen: ListScreen.OUTERNAL_EXAM,
    name: "Triệu chứng",
    fieldCode: "symptomDetail",
  },
  { screen: ListScreen.OUTERNAL_EXAM, name: "Lý do", fieldCode: "reasonVisit" },
  {
    screen: ListScreen.OUTERNAL_EXAM,
    name: "Quá trình bệnh lý",
    fieldCode: "diseaseProcess",
  },
  { screen: ListScreen.OUTERNAL_EXAM, name: "Dặn dò", fieldCode: "note" },
  {
    screen: ListScreen.OUTERNAL_EXAM,
    name: "Chẩn đoán sơ bộ",
    fieldCode: "preliminaryDiagnosis",
  },
  {
    screen: ListScreen.OUTERNAL_EXAM,
    name: "Chẩn đoán kết luận",
    fieldCode: "finalDiagnosis",
  },

  {
    screen: ListScreen.IN_PATIENT_PATIENT_INFO,
    name: "Diễn biến bệnh",
    fieldCode: "diseaseProgression",
  },
  {
    screen: ListScreen.IN_PATIENT_PATIENT_INFO,
    name: "Y lệnh khác",
    fieldCode: "otherDoctorOrder",
  },

  {
    screen: ListScreen.TREARMENT_REGIMEN,
    name: "Y lệnh khác",
    fieldCode: "otherDoctorOrder",
  },
  {
    screen: ListScreen.TREARMENT_REGIMEN,
    name: "Ý kiến trưởng khoa",
    fieldCode: "chiefPhysicianOpinion",
  },

  {
    screen: ListScreen.TREARMENT_REGIMEN,
    name: "Theo dõi diễn biến",
    fieldCode: "monitorProgres",
  },
  {
    screen: ListScreen.TREARMENT_REGIMEN,
    name: "Thực hiện y lệnh, chăm sóc",
    fieldCode: "executeCareOrders",
  },
];

export const CODECHART = {
  height: "vee-00030502",
  weight: "vee-00030501",
  temperature: "vee-00030508",
  systolicPressure: "vee-00030505",
  diastolicPressure: "vee-00030506",
  heartbeat: "vee-00030503",
};

export const MedicalRecordTypeValue = {
  LIST: 2,
  SINGLE: 1,
};

export const MedicalRecordType = [
  { value: MedicalRecordTypeValue.SINGLE, name: "Trường đơn" },
  { value: MedicalRecordTypeValue.LIST, name: "Danh sách" },
];

export const MedicalRecordTypeTemplateValue = {
  MedicalRecord: 1,
  CaringSheet: 2,
  PatientClassification: 3,
  ExamForm: 4,
};

export const MedicalRecordTypeTemplate = [
  { value: MedicalRecordTypeTemplateValue.MedicalRecord, name: "Bệnh án" },
  { value: MedicalRecordTypeTemplateValue.CaringSheet, name: "Phiếu chăm sóc" },
  {
    value: MedicalRecordTypeTemplateValue.PatientClassification,
    name: "Phiếu phân loại người bệnh tại khoa cấp cứu",
  },
  { value: MedicalRecordTypeTemplateValue.ExamForm, name: "Phiếu khám" },
];

export const MenuRoutes = [
  { name: "Tờ điều trị", path: "treatment-regimen" },
  { name: "Phiếu chăm sóc", path: "nursing-work" },
  { name: "Vật tư y tế", path: "consumable-supplies" },
  { name: "Chỉ định CLS", path: "paraclinical-services" },
  { name: "Cấp thuốc", path: "medical-instruction" },
  { name: "Phiếu truyền dịch", path: "infusion-sheet" },
  { name: "Công khai dịch vụ KCB", path: "public-services-kbc" },
  { name: "Thông tin bệnh nhân thăm khám", path: "general-visit" },
  { name: "Thông tin bệnh nhân", path: "patient-info" },
  { name: "Chỉnh sửa bệnh nhân", path: "create-or-edit-patient" },
  { name: "Hóa đơn bệnh nhân", path: "invoice-patient" },
  { name: "Thông tin bệnh nhân", path: "in-campaign-view-info-patient" },
  { name: "Lịch hẹn khám", path: "appointment-schedule" },
  { name: "Thông tin chi tiết nhân sự", path: "staff-info" },
];

export const MenuRoutesNotProgressAxios = [
  PathModule.REQUEST_NUMBER + "/request-patient-full-screen",
  PathModule.REQUEST_NUMBER + "/request-number-full-screen",
  PathModule.REQUEST_NUMBER + "/request-imgStudy-full-screen",
];

export const LIST_ANESTHESIAMETHOD = [
  { value: 1, name: "Gây mê nội khí quản" },
  { value: 2, name: "Gây tê tủy sống kết hợp ngoài màng cứng" },
  { value: 2, name: "Tê vùng kết hợp mê tĩnh mạch" },
  { value: 3, name: "Tê vùng + tê tại chỗ" },
  { value: 4, name: "Gây tê nội khí quản hoặc Mask thanh quản" },
  { value: 5, name: "Gây tê đám rối cổ" },
  { value: 6, name: "Gây tê vùng kết hợp mê tĩnh mạch" },
  { value: 6, name: "Mê nội khí quản kết hợp PCA tĩnh mạch" },
  { value: 7, name: "Gây mê toàn thân kết hợp giảm đau" },
  { value: 8, name: "Tê tủy sống kết hợp giảm đau PCA tĩnh mạch" },
  { value: 9, name: "Gây mê nội khí quản kết hợp tê ngoài màng cứng" },
  { value: 10, name: "Gây mê Mask thanh quản" },
  { value: 11, name: "Gây tê tủy sống" },
  { value: 12, name: "Gây tê ngoài màng cứng" },
  { value: 13, name: "Gây tê đám rối thần kinh cánh tay" },
  { value: 14, name: "Mê tĩnh mạch" },
  { value: 15, name: "Tê tại chỗ" },
  { value: 16, name: "Tiền mê, tê tại chỗ" },
  { value: 17, name: "Khác" },
];

export const SURGICAL_TYPE = [
  { value: 1, name: "Phẫu thuật, thủ thuật loại đặc biệt" },
  { value: 2, name: "Phẫu thuật, thủ thuật loại I" },
  { value: 3, name: "Phẫu thuật, thủ thuật loại II" },
  { value: 4, name: "Phẫu thuật, thủ thuật loại III" },
];

export const SURGICAL_METHODS = [
  { value: 1, name: "Phẫu thuật mở" },
  { value: 2, name: "Phẫu thuật nội soi" },
  { value: 3, name: "Phẫu thuật bằng robot" },
  { value: 4, name: "Phẫu thuật vi phẫu" },
];

export const MEDICAL_EXAM_VISIT_REASON = [
  { value: 1, name: "Khám sức khỏe định kỳ" },
  { value: 2, name: "Khám sức khỏe của người lái xe" },
  { value: 3, name: "Khám sức khỏe định kỳ của người lái ô tô" },
];

export const PAIN_RELIEF = [
  { value: 1, name: "Gây tê ngoài màng cứng liên tục" },
  { value: 2, name: "Gây tê ngoài màng cứng ngắt quãng" },
  { value: 3, name: "Gây tê cạnh cột sống" },
  { value: 4, name: "Gây tê đám rối liên tục" },
  { value: 5, name: "Giảm đau do BN tự kiểm soát đường tĩnh mạch (PCA-IV)" },
  {
    value: 6,
    name: "Giảm đau do BN tự kiểm soát gây tê ngoài màng cứng (PCEA)",
  },
  { value: 7, name: "Morphine tủy sống" },
  { value: 8, name: "Đa phương thức" },
];

export const LIST_BLOOD_TYPE = [
  { value: 1, name: "A" },
  { value: 1, name: "A+" },
  { value: 2, name: "A-" },
  { value: 3, name: "B" },
  { value: 3, name: "B+" },
  { value: 4, name: "B-" },
  { value: 5, name: "AB" },
  { value: 5, name: "AB+" },
  { value: 6, name: "AB-" },
  { value: 7, name: "O" },
  { value: 7, name: "O+" },
  { value: 8, name: "O-" },
];

export const VEHICLE_CLASS = [
  { value: 1, name: "A1" },
  { value: 2, name: "B1" },
  { value: 3, name: "A2" },
  { value: 4, name: "A3" },
  { value: 5, name: "A4" },
  { value: 6, name: "B2" },
  { value: 7, name: "C" },
  { value: 8, name: "D" },
  { value: 9, name: "E" },
  { value: 10, name: "FB2" },
  { value: 11, name: "FC" },
  { value: 12, name: "FD" },
  { value: 13, name: "FE" },
  { value: 14, name: "B0.1" },
];

export const CUSTOMER_STATUS_SERVICE = [
  {
    value: 1,
    name: "Chưa thực hiện",
  },
  {
    value: 2,
    name: "Đã thực hiện",
  },
];

export const notStart = 1;
export const completed = 2;

export const COMFIRM_STATUS = [
  { value: 1, name: "Chưa chốt" },
  { value: 2, name: "Đã chốt danh sách" },
];

export const TYPE_FOOD = [
  { value: 1, name: "Món ăn" },
  { value: 2, name: "Nguyên liệu" },
];

export const REQUEST_TYPE = [
  { value: 1, name: "Bác sĩ" },
  { value: 2, name: "Khách hàng" },
  { value: 3, name: "Đối tác" },
];

export const REQUEST_STATUS = [
  { value: 1, name: "Chờ phê duyệt" },
  { value: 2, name: "Đã phê duyệt" },
  { value: 3, name: "Đã từ chối" },
  { value: 4, name: "Đang thực hiện" },
  { value: 5, name: "Đã thực hiện" },
  { value: 6, name: "Chờ thông tin bổ sung" },
];
export const SURGERY_TIMES_PRIORITY = [
  { value: 1, name: "Cao" },
  { value: 2, name: "Trung bình" },
  { value: 3, name: "Thấp" },
];

export const SURGERY_PATIENT_STATUS = [
  {
    value: 1,
    name: "Mới",
  },
  {
    value: 2,
    name: "Đã phê duyệt",
  },
  {
    value: 3,
    name: "Đã xếp lịch mổ",
  },
  {
    value: 4,
    name: "Đang thực hiện mổ",
  },
  {
    value: 3,
    name: "Đã hoàn thành",
  },
];
export const SURGERY_SCHEDULE_STATUS = [
  {
    value: 1,
    name: "Chưa thực hiện",
    color: "#f0ad4e",
  },
  {
    value: 2,
    name: "Đang thực hiện",
    color: "#5bc0de",
  },
  {
    value: 3,
    name: "Đã thực hiện",
    color: "#5cb85c",
  },
];

export const CHOSE_PRICE_SERVICE_OPTIONS = [
  { name: "Lấy giá theo đối tượng", value: 1 },
  { name: "Lấy giá mặc định", value: 2 }, // mặc định code chỗ kia là lấy default là giá trị thứ 2 của mảng nếu nay mai thay đổi ưu tiên để giá trị mặc định là mảng có index = 1
];

export const LIST_TYPE_OPTION = [
  {
    name: "INBOARDING_PAYMENT_METHOD",
    type: "select",
    options: [
      { name: "Thanh toán từng dịch vụ trước khi thực hiện", value: "1" },
      { name: "Tạm ứng trước khi thực hiện dịch vụ", value: "2" },
    ],
  },
  {
    name: "OUTBOARDING_PAYMENT_METHOD",
    type: "select",
    options: [
      { name: "Thanh toán từng dịch vụ trước khi thực hiện", value: "1" },
      { name: "Tạm ứng trước khi thực hiện dịch vụ", value: "2" },
    ],
  },
  {
    name: "EMERGENCY_PAYMENT_METHOD",
    type: "select",
    options: [
      { name: "Thanh toán từng dịch vụ trước khi thực hiện", value: "1" },
      { name: "Tạm ứng trước khi thực hiện dịch vụ", value: "2" },
    ],
  },
  { name: "INBOARDING_PAYMENT_REQUIRED", type: "boolean" },
  { name: "OUTBOARDING_PAYMENT_REQUIRED", type: "boolean" },
  { name: "EMERGENCY_PAYMENT_REQUIRED", type: "boolean" },
  { name: "INBOARDING_ADVANCE_DISCREPANCY", type: "number" },
  { name: "OUTBOARDING_ADVANCE_DISCREPANCY", type: "number" },
  { name: "EMERGENCY_ADVANCE_DISCREPANCY", type: "number" },
  { name: "IS_NOT_EXAM", type: "boolean" },
  { name: "SELECT_OBJECT_BY_NUMBER", type: "boolean" },
  { name: "PRINT_DRUG_ORDER_SEPARATE", type: "boolean" },
  { name: "ONLY_USE_SHI_PRICE_EXPORT_XML", type: "boolean" },
  { name: "OUTERNAL_EXAM_SUMMARY_SCREEN", type: "boolean" },
  { name: "SHOW_THE_CALL_SCREEN_RECEPTION", type: "boolean" },
  { name: "SHOW_THE_CALL_SCREEN_EXAM", type: "boolean" },
  { name: "USE_DIRECT_COMPANION", type: "boolean" },
  {
    name: "CHOSE_PRICE_SERVICE",
    type: "select",
    options: [
      { name: "Lấy giá theo đối tượng", value: "1" },
      { name: "Lấy giá mặc định", value: "2" },
    ],
  },
  {
    name: "DEFAULT_SERVICE_PAYMENT",
    type: "select",
    options: [
      { name: "Dịch vụ không ghi nợ", value: "false" },
      { name: "Lấy cả dịch vụ ghi nợ", value: "true" },
    ],
  },
  {
    name: "MEDI_REQUEST_TYPE_TO_SEND_STORE",
    type: "select",
    options: [
      { name: "Gửi đơn thuốc BHYT sang kho", value: "insurance_type" },
      {
        name: "Gửi đơn thuốc BHYT và đơn DV sang kho",
        value: "insurance_and_service",
      },
      { name: "Gửi đơn thuốc tổng hợp sang kho", value: "synthetic" },
      {
        name: "Gửi tất cả các đơn trừ đơn mua ngoài",
        value: "all_except_other_medi_type",
      },
    ],
  },
  { name: "SEND_STORE_REQUEST_TO_STORE", type: "boolean" },
  { name: "STORE_REQUEST_EXPORT_SOURCE_CODE", type: "text" },
  { name: "REQUIRED_CHILDREN_AND_OLE", type: "boolean" },
  { name: "CACULATE_DIFFERENCE_MEDICATION_REQUEST", type: "boolean" },
  { name: "CACULATE_DIFFERENCE_MEDICAL_SUPPLY_REQUEST", type: "boolean" },
  { name: "CREATE_INVOICE_MANUAL", type: "boolean" },
  { name: "DEFAULT_ADD_HOSPITAL", type: "boolean" },
  {
    name: "OUTPATIENT_MEDICATION_REQUEST_ORDER_TYPE",
    type: "select",
    options: [
      { name: "Kê thuốc theo tab (BHYT - Dịch vụ - Thuốc ngoài)", value: "1" },
      { name: "Kê thuốc tổng hợp", value: "2" },
    ],
  },
  {
    name: "INPATIENT_MEDICATION_REQUEST_ORDER_TYPE",
    type: "select",
    options: [
      { name: "Kê thuốc theo tab (BHYT - Dịch vụ - Thuốc ngoài)", value: "1" },
      { name: "Kê thuốc tổng hợp", value: "2" },
    ],
  },
  {
    name: "SERGERYPATIENT_MEDICATION_REQUEST_ORDER_TYPE",
    type: "select",
    options: [
      { name: "Kê thuốc theo tab (BHYT - Dịch vụ - Thuốc ngoài)", value: "1" },
      { name: "Kê thuốc tổng hợp", value: "2" },
    ],
  },
  { name: "CHECK_PATIENT_TREATMENT_STATUS", type: "boolean" },
  { name: "LOGO", type: "image" },
  { name: "TREATMENT_PLAN_CARD_PRINT_LOGO", type: "image" },
  { name: "COMBINE_EPISODE_OF_CARE_HOSPITAL_FEE", type: "boolean" },
  { name: "IMAGE_SIZE", type: "number" },
  { name: "MODULE_VISIT_HOSPITAL_FEE", type: "boolean" },
  { name: "SENT_NATIONAL_PRESCRIPTION", type: "boolean" },
  { name: "SEPARATE_SERVICE_REQUEST", type: "boolean" },
  { name: "UPLOAD_NUMBER_IMG", type: "number" },
  { name: "CREATE_INVOICE_MANUAL", type: "boolean" },
  { name: "VIEW_MONTHS_IF_UNDER_5_YEARS_OLD", type: "boolean" },
  //tách mã mẫu theo chỉ định
  { name: "SEPARATE_SAMPLE_CODE_BY_REQUEST", type: "boolean" },
  { name: "PRINT_EXAM_SV_REQ_WITH_OTHER", type: "boolean" },
  { name: "FORMAT_MONEY_NUMBER", type: "number" },
  { name: "VALIDATE_PHONENUMBER", type: "boolean" },
  { name: "GET_TEST_SAMPLE_CODE_HANDLE", type: "boolean" },
  { name: "SHOW_HEADER_WHEN_PRINT", type: "boolean" },
  { name: "ENTER_EXAMINATION_INSTRUCTION", type: "textarea" },
  { name: "SET_TIMEOUT_RELOAD", type: "number" },
  { name: "IS_CHECK_RESULT_LATER", type: "boolean" },
  { name: "VIEW_DRIVER_LICENSE", type: "boolean" },
  { name: "FORM_EXAM_REGPRINT_PORTRAIT", type: "boolean" },
  { name: "SHOW_COMPANY", type: "boolean" },
  { name: "CHOOSE_STORE_IN_TAB_EXTERAL_MEDICINE", type: "boolean" },
  { name: "SHOW_LOAD_IMAGE_CLS_EXAMINATION", type: "boolean" },
  { name: "GET_UNIT_BY_MEDICAL_EQUIPMENT", type: "boolean" },
  {
    name: "TYPE_EXAM",
    type: "select",
    options: [
      { name: "Dịch vụ", value: "1" },
      { name: "Bảo hiểm", value: "2" },
    ],
  },
  { name: "SHOW_COLUMN_SERVICE_GROUP", type: "boolean" },
  { name: "SHOW_PRINT_VOUCHER_OLD", type: "boolean" },
  { name: "SHOW_RESULT_SAMPLE", type: "boolean" },
  { name: "CLOSE_SIDE_BAR_GROUP_MEDICAL", type: "boolean" },
  { name: "SHOW_VISIT_RESULT", type: "boolean" },
  { name: "REGISTER_SERVICE_SIGNLE", type: "boolean" },
  { name: "CHOOSE_PATIENT_TYPE_SERVICE_ADVISE", type: "boolean" },
  { name: "MULTIPLE_UPLOAD_IMAGES_TREATMENT", type: "boolean" },
  { name: "ASYNC_DATA_CRM_PATIENT", type: "boolean" },
  { name: "ENABLE_HISTORY", type: "boolean" },
  { name: "CHECK_TOUR", type: "boolean" },
  { name: "DISPLAY_PROMOTION", type: "boolean" },
  { name: "SEARCH_ELASTIC", type: "boolean" },
  { name: "KTV_HAS_ASSIGN_TREATMENT", type: "boolean" },
  { name: "CHECKIN_IN_FORM_PATIENT", type: "boolean" },
  { name: "VALIDATE_PAYMENT_TREATMENT", type: "boolean" },
  { name: "SHOW_CHART_REPORT_SOURCE_SERVICE", type: "boolean" },
  { name: "SHOW_CHART_REPORT_SOURCE_CUSTOMER", type: "boolean" },
  { name: "SHOW_UPDATE_TOUR_AND_IMAGE_TREATMENT", type: "boolean" },
  { name: "APPOINTMENT_TYPE_KTV_SELECT", type: "boolean" },
  { name: "SELECT_ALL_ITEM_FEE", type: "boolean" },
  { name: "SHOW_EXPENSE_OCCURRED", type: "boolean" },
  { name: "PERMISSION_ROLE_HIS_PAYMENT", type: "boolean" },
  { name: "SHOW_LOYALTY_TAB", type: "boolean" },
  { name: "REQUIRED_CTKM_DISCOUNT", type: "boolean" },
  { name: "AUTO_REWARD_ON_PAYMENT", type: "boolean" },
  { name: "LOGOUT_LOG_BROWSER", type: "boolean" },
  { name: "VALIDATE_MAXIMUM_EXPORT_CURRENT_QUANTITY", type: "boolean" },
  { name: "CHECK_DISCOUNT", type: "boolean" },
  { name: "DEFAULT_GET_WARRANTY", type: "boolean" },
  { name: "REQUIRED_PERFORM_ROOM_IN_TREATMENT", type: "boolean" },
  { name: "HIDE_PHONE_NUMBER", type: "boolean" },
  { name: "ACCEPT_CHANGE_PASSWORD", type: "boolean" },
  { name: "IS_CHECK_MANY_CHECKIN_ON_DAY", type: "boolean" },
  { name: "REQUIRED_CTKM", type: "boolean" },
  { name: "CHECK_ELASTIC_LEADS", type: "boolean" },
  { name: "DISABLE_EDIT_RETAINED_AMOUNT", type: "boolean" },
  {
    name: "FEE_VOUCHER_PRINT_HEADER_MODE",
    type: "select",
    options: [
      { name: "Theo cơ sở (cũ)", value: "department" },
      { name: "Theo pháp nhân", value: "legal_entity" },
    ],
  },
];

// Trạng thái của bước trong dịch vụ
export const DiagnosticResultStepStatus = {
  UNCOMPLETED: {
    value: 1,
    name: "Chưa thực hiện",
  },
  ON_PROCESS: {
    value: 2,
    name: "Đang thực hiện",
  },
  COMPLETED: {
    value: 3,
    name: "Đã hoàn thành",
  },

  getListData: function () {
    return Object.values(this).filter(
      (item) => typeof item === "object" && item.name
    );
  },

  fromValue: function (value) {
    return this.getListData().find((item) => item.value === value);
  },
};

// Loại ảnh kết quả điều trị
export const LADiagnosticImageResultType = {
  BEFORE_TREATMENT: {
    value: 1,
    code: "Trước điều trị",
  },
  AFTER_TREATMENT: {
    value: 2,
    code: "Sau điều trị",
  },

  getListData: function () {
    return Object.values(this).filter(
      (item) => typeof item === "object" && item.name
    );
  },

  fromValue: function (value) {
    return this.getListData().find((item) => item.value === value);
  },
};

export const SystemConfigCode = {
  SEEKER_PIN_DEFAULT: {
    code: "SEEKER_PIN_DEFAULT",
    name: "Cấu hình mã PIN mặc định cho người tìm việc",
  },
  SEEKER_NAME_DEFAULT: {
    code: "SEEKER_NAME_DEFAULT",
    name: "Tên mặc định cho người tìm việc",
  },
  USERNAMESHI: {
    code: "USERNAMESHI",
    name: "Tên người dùng hệ thống SHI",
  },
  ENCODESHI: {
    code: "ENCODESHI",
    name: "Mã hóa SHI",
  },
  FACILITY_CODE: {
    code: "FACILITY_CODE",
    name: "Mã cơ sở khám chữa bệnh",
  },
  FACILITY_PROVINCE_CODE: {
    code: "FACILITY_PROVINCE_CODE",
    name: "Mã tỉnh/thành của cơ sở",
  },
  LEADER_SOCIAL_INSURANCE_CODE: {
    code: "LEADER_SOCIAL_INSURANCE_CODE",
    name: "Mã BHXH của người đứng đầu",
  },
  ONLY_USE_SHI_PRICE_EXPORT_XML: {
    code: "ONLY_USE_SHI_PRICE_EXPORT_XML",
    name: "Chỉ dùng đơn giá BHYT khi xuất XML",
  },
  IS_DEFAULT_FIELDS: {
    code: "IS_DEFAULT_FIELDS",
    name: "Giá trị mặc định cho từng màn hình",
  },
  MEDI_REQUEST_TYPE_TO_SEND_STORE: {
    code: "MEDI_REQUEST_TYPE_TO_SEND_STORE",
    name: "Loại đơn thuốc gửi sang kho",
  },
  PRE_SURGERY_EXAM_CODE: {
    code: "PRE_SURGERY_EXAM_CODE",
    name: "Mã phiếu khám trước mổ",
  },
  PRE_SURGERY_SUMMARY_CODE: {
    code: "PRE_SURGERY_SUMMARY_CODE",
    name: "Mã phiếu sơ kết trước mổ",
  },
  CONSCIOUS_FORM_CODE: {
    code: "CONSCIOUS_FORM_CODE",
    name: "Mã phiếu hồi tỉnh",
  },
  ANESTHESIA_AND_RESUSCITATION_CODE: {
    code: "ANESTHESIA_AND_RESUSCITATION_CODE",
    name: "Mã phiếu gây mê hồi sức",
  },
  SEND_STORE_REQUEST_TO_STORE: {
    code: "SEND_STORE_REQUEST_TO_STORE",
    name: "Gửi yêu cầu xuất kho sang kho",
  },
  STORE_REQUEST_EXPORT_SOURCE_CODE: {
    code: "STORE_REQUEST_EXPORT_SOURCE_CODE",
    name: "Mã nguồn phiếu xuất kho sản phẩm sang kho",
  },
  CACULATE_DIFFERENCE_MEDICATION_REQUEST: {
    code: "CACULATE_DIFFERENCE_MEDICATION_REQUEST",
    name: "Tính chênh lệch đơn thuốc",
  },
  CACULATE_DIFFERENCE_MEDICAL_SUPPLY_REQUEST: {
    code: "CACULATE_DIFFERENCE_MEDICAL_SUPPLY_REQUEST",
    name: "Tính chênh lệch vật tư y tế",
  },
  PATIENT_TYPE_SERVICE_CODE: {
    code: "PATIENT_TYPE_SERVICE_CODE",
    name: "Mã đối tượng bệnh nhân (BHYT)",
  },
  CREATE_INVOICE_MANUAL: {
    code: "CREATE_INVOICE_MANUAL",
    name: "Tạo hóa đơn thủ công",
  },
  hourGenCodeStoreRequest: {
    code: "hourGenCodeStoreRequest",
    name: "Giờ tự động sinh mã xuất kho",
  },
  CHECK_PATIENT_TREATMENT_STATUS: {
    code: "CHECK_PATIENT_TREATMENT_STATUS",
    name: "Kiểm tra trạng thái điều trị bệnh nhân",
  },
  OUTPATIENT_MEDICATION_REQUEST_ORDER_TYPE: {
    code: "OUTPATIENT_MEDICATION_REQUEST_ORDER_TYPE",
    name: "Kiểu kê đơn thuốc ngoại trú",
  },
  INPATIENT_MEDICATION_REQUEST_ORDER_TYPE: {
    code: "INPATIENT_MEDICATION_REQUEST_ORDER_TYPE",
    name: "Kiểu kê đơn thuốc nội trú",
  },
  COMBINE_EPISODE_OF_CARE_HOSPITAL_FEE: {
    code: "COMBINE_EPISODE_OF_CARE_HOSPITAL_FEE",
    name: "Gộp đợt điều trị tính viện phí",
  },
  CHOSE_PRICE_SERVICE: {
    code: "CHOSE_PRICE_SERVICE",
    name: "Chọn đơn giá mặc định",
  },
  SEPARATE_SERVICE_REQUEST: {
    code: "SEPARATE_SERVICE_REQUEST",
    name: "Tách đơn giá theo đối tượng",
  },
  SEPARATE_MEDI_REQ_BY_CATEGORY: {
    code: "SEPARATE_MEDI_REQ_BY_CATEGORY",
    name: "Tách thuốc theo nhóm",
  },
  SEPARATE_SAMPLE_CODE_BY_REQUEST: {
    code: "SEPARATE_SAMPLE_CODE_BY_REQUEST",
    name: "Tách mã mẫu theo chỉ định",
  },
  ORG_NAME: {
    code: "ORG_NAME",
    name: "Tên cơ sở khám chữa bệnh",
  },
  FEE_VOUCHER_PRINT_HEADER_MODE: {
    code: "FEE_VOUCHER_PRINT_HEADER_MODE",
    name: "Chế độ header phiếu thu (theo cơ sở / theo pháp nhân)",
  },
  FEE_VOUCHER_LEGAL_ENTITY_BY_DEPT: {
    code: "FEE_VOUCHER_LEGAL_ENTITY_BY_DEPT",
    name: "Map pháp nhân theo mã cơ sở (phiếu thu)",
  },
  ADDRESS_HOSPITAL: {
    code: "ADDRESS_HOSPITAL",
    name: "Địa chỉ bệnh viện",
  },
  VIEW_MEDI_REQ_INVOICE_SERVICE_RECEPTION: {
    code: "VIEW_MEDI_REQ_INVOICE_SERVICE_RECEPTION",
    name: "Xem đơn thuốc dịch vụ tại lễ tân",
  },
  FORMAT_MONEY_NUMBER: {
    code: "FORMAT_MONEY_NUMBER",
    name: "Định dạng số tiền",
  },
  GET_TEST_SAMPLE_CODE_HANDLE: {
    code: "GET_TEST_SAMPLE_CODE_HANDLE",
    name: "Lấy mã xét nghiệm từ nhập",
  },
  VOUCHER_CODE: {
    code: "VOUCHER_CODE",
    name: "Mã hóa đơn",
  },
  IS_CHECK_RESULT_LATER: {
    code: "IS_CHECK_RESULT_LATER",
    name: "Kiểm tra kết quả dịch vụ kỹ thuật sau",
  },
  OUTPATIENT_VISIT_TYPE: {
    code: "OUTPATIENT_VISIT_TYPE",
    name: "Loại khám ngoại trú",
  },
  DEFAULT_PATIENT_TYPE_CODE: {
    code: "DEFAULT_PATIENT_TYPE_CODE",
    name: "Mã đối tượng bệnh nhân mặc định",
  },
  DEFAULT_CUSTOMER_SOURCE: {
    code: "DEFAULT_CUSTOMER_SOURCE",
    name: "Nguồn khách hàng mặc định",
  },
  GET_UNIT_BY_MEDICAL_EQUIPMENT: {
    code: "GET_UNIT_BY_MEDICAL_EQUIPMENT",
    name: "Lấy đơn vị theo thiết bị y tế",
  },
  PHONE_NUMBER: {
    code: "PHONE_NUMBER",
    name: "Số điện thoại",
  },
  WEBSITE: {
    code: "WEBSITE",
    name: "Website",
  },
  EMAIL: {
    code: "EMAIL",
    name: "Email",
  },
  AUTO_GEN_PATIENT_CODE_BY_JOB: {
    code: "AUTO_GEN_PATIENT_CODE_BY_JOB",
    name: "Tự động sinh mã bệnh nhân theo công việc",
  },
  CUSTOMER_APPOINTMENT_URL: {
    code: "CUSTOMER_APPOINTMENT_URL",
    name: "Đường dẫn đặt lịch khách hàng",
  },
  SYNC_DEPAERTMENT_TYPE_CODE: {
    code: "SYNC_DEPAERTMENT_TYPE_CODE",
    name: "Mã loại cơ sở đồng bộ HR",
  },
  PROCEDURE_ENCOUNTER_TYPE_CODE: {
    code: "PROCEDURE_ENCOUNTER_TYPE_CODE",
    name: "Mã loại lần khám thủ thuật",
  },
  LOGO: {
    code: "LOGO",
    name: "Logo",
  },
  TREATMENT_PLAN_CARD_PRINT_LOGO: {
    code: "TREATMENT_PLAN_CARD_PRINT_LOGO",
    name: "Logo trong phiếu in liệu trình",
  },
  POSITION_CONSULTANT: {
    code: "POSITION_CONSULTANT",
    name: "Mã chức danh nhân viên tư vấn",
  },

  getListData: function () {
    return Object.values(this).filter(
      (item) => typeof item === "object" && item.code
    );
  },

  fromCode: function (code) {
    return this.getListData().find((item) => item.code === code);
  },
};

export const ListFamilyRelationshipInterger = [
  { value: 1, name: "Ông" },
  { value: 2, name: "Bà" },
  { value: 3, name: "Bố" },
  { value: 4, name: "Mẹ" },
  { value: 5, name: "Chồng" },
  { value: 6, name: "Vợ" },
  { value: 7, name: "Anh trai" },
  { value: 8, name: "Chị gái" },
  { value: 9, name: "Em trai" },
  { value: 10, name: "Em gái" },
  { value: 11, name: "Cháu" },
];

export const SHICategoryType = [
  { value: 1, name: "Thuốc" },
  { value: 2, name: "DVKT" },
];

export const SERVICE_TYPE_CODE = [
  { name: "Xét nghiệm", value: "LabTest" },
  { name: "Chẩn đoán bằng hình ảnh", value: "diagnostic_imaging" },
  { name: "Ngày giường bệnh ban ngày", value: "Day_bed_daytime" },
  { name: "Dịch Vụ Y Tế", value: "DVYT" },
  { name: "Ngày giường bệnh điều trị nội trú", value: "bedridden_service" },
  { name: "Ngày giường lưu", value: "Bed_date_saved" },
  { name: "Khám bệnh và kiểm tra sức khoẻ", value: "examination" },
  { name: "Thủ thuật", value: "Procedures" },
  { name: "Phẫu thuật", value: "Surgery" },
  { name: "Giường bệnh", value: "bedridden_service" },
];

export const TYPE_SAMPLE_CODE_SAMPLED = 2;

export const TYPE_SAMPLE_CODE = [
  { name: "Mới được kê", value: 1 },
  { name: "Đã lấy mẫu", value: TYPE_SAMPLE_CODE_SAMPLED },
  { name: "Đang thực hiện", value: 3 },
  { name: "Đã kết thúc", value: 4 },
];
export const VISIT_CATEGORY = [
  { name: "Ngoại trú", value: 1 },
  { name: "Nội trú", value: 2 },
  // { name: "Khám đoàn", value: 3 },
];
export const SAMPLE_TYPE = [
  { name: "Máu", value: 1 },
  { name: "Nước tiểu", value: 2 },
  { name: "Nước bọt", value: 3 },
  { name: "Đờm", value: 4 },
  { name: "Phân", value: 5 },
  { name: "Khác", value: 6 },
];
export const SAMPLE_STATUS = [
  { name: "Chưa xử lý", value: 1 },
  { name: "Đang xử lý", value: 2 },
  { name: "Đã xử lý", value: 3 },
];

export const SHI_LEVEL = [
  { value: "0", name: "Chưa phân quyền" },
  { value: "1", name: "Trung ương" },
  { value: "2", name: "Tỉnh" },
  { value: "3", name: "Huyện" },
  { value: "4", name: "Xã" },
];

export const SHI_RANKS = [
  { value: "0", name: "Chưa xếp hạng" },
  { value: "1", name: "Hạng 1" },
  { value: "2", name: "Hạng 2" },
  { value: "3", name: "Hạng 3" },
  { value: "4", name: "Hạng 4" },
  { value: "5", name: "Hạng đặc biệt" },
];

export const LIST_ACCIDENT_CODE = [
  { name: "Không", value: 0 },
  { name: "Tai nạn giao thông", value: 1 },
  { name: "Tai nạn lao động", value: 2 },
  { name: "Tai nạn dưới nước", value: 3 },
  { name: "Bỏng", value: 4 },
  { name: "Bạo lực, xung đột", value: 5 },
  { name: "Tự tử", value: 6 },
  { name: "Ngộ độc các loại", value: 7 },
  { name: "Khác", value: 8 },
];

export const PLACEREFERRAL_OPTIONS = [
  {
    value: 1,
    name: "Tự đến",
  },
  {
    value: 2,
    name: "Cơ quan y tế",
  },
  {
    value: 3,
    name: "Đơn vị quốc phòng",
  },
  {
    value: 4,
    name: "Cơ sở khám chữa bệnh (Danh sách bệnh viện)",
  },
];

export const TRANSFER_TO = [
  {
    value: 1,
    name: "Tuyến trên",
  },
  {
    value: 2,
    name: "Nội tuyến",
  },
];

export const INPATIENT_STATUS = [
  // { name: "Mới", value: 0 },
  // { name: "Đã đăng ký khám", value: 6 },
  // { name: "Đang khám ngoại trú", value: 7 },
  { name: "Chờ nhập viện", value: 8 },
  { name: "Vào viện", value: 1 }, // vào viện chờ điều trị - đã nhập viện
  { name: "Đang điều trị", value: 2 },
  { name: "Đang điều trị và chờ tiếp nhận", value: 3 }, // đang điều trị và chờ tiếp nhận
  { name: "Ra viện chưa thanh toán", value: 4 }, // yêu cầu ra viện
  { name: "Quyết toán và ra viện", value: 5 },
  { name: "Chuyển viện", value: 9 },
  { name: "Ra viện", value: 10 },
  { name: "Tử vong", value: 11 },
];

export const PATIENT_TREATMENT_STATUS = [
  { name: "Mới", value: 0 },
  { name: "Đã đăng ký khám", value: 6 },
  { name: "Đang khám ngoại trú", value: 7 },
  { name: "Chờ nhập viện", value: 8 },
  { name: "Vào viện", value: 1 }, // vào viện chờ điều trị - đã nhập viện
  { name: "Đang điều trị nội trú", value: 2 },
  { name: "Đang điều trị và chờ tiếp nhận", value: 3 }, // đang điều trị và chờ tiếp nhận
  { name: "Yêu cầu ra viện", value: 4 }, // yêu cầu ra viện
  { name: "Quyết toán và ra viện", value: 5 },
  { name: "Chuyển viện", value: 9 },
  { name: "Ra viện", value: 10 },
  { name: "Tử vong", value: 11 },
  { name: "Đang điều trị ngoại trú", value: 12 },
  { name: "Kết thúc điều trị ngoại trú", value: 13 },
];

export const TYPE_GLOBAL_PROPOTIES_REFUND_REASON = "refund_reason";
export const TYPE_GLOBAL_PROPOTIES_CANCEL_REASON = "cancel_reason";
export const TYPE_GLOBAL_PROPOTIES_BANK = "bank";
export const TYPE_GLOBAL_PROPOTIES_POS_LIST = "pos_list";
export const TYPE_GLOBAL_PROPOTIES_POS_VNPAY_TRAGOP = "pos_vnpay_tragop_list";
export const TYPE_GLOBAL_PROPOTIES_HOME_CREDIT_CODE = "home_creadit_list";
export const TYPE_GLOBAL_PROPOTIES = [
  { value: TYPE_GLOBAL_PROPOTIES_REFUND_REASON, name: "Lý do hoàn" },
  { value: TYPE_GLOBAL_PROPOTIES_CANCEL_REASON, name: "Lý do hủy" },
  { value: TYPE_GLOBAL_PROPOTIES_BANK, name: "Ngân hàng" },
  { value: TYPE_GLOBAL_PROPOTIES_POS_LIST, name: "Danh mục máy POS" },
  {
    value: TYPE_GLOBAL_PROPOTIES_POS_VNPAY_TRAGOP,
    name: "Danh mục máy POS VNPAY TRAGOP",
  },
  {
    value: TYPE_GLOBAL_PROPOTIES_HOME_CREDIT_CODE,
    name: "Danh mục Home creadit",
  },
];

export const HOSPITAL_DISCHARGE_STATUS = [
  { name: "Ra viện", value: 1 },
  { name: "Chuyển viện", value: 2 },
  { name: "Trốn viện", value: 3 },
  { name: "Xin ra viện", value: 4 },
  { name: "Chạy thận", value: 5 },
];

export const DEATH_TIME = [
  { name: "Trong 24 giờ vào viện", value: 1 },
  { name: "Sau 24 giờ vào viện", value: 2 },
  { name: "Trên bàn phẫu thuật", value: 3 },
];

export const DEATH_ANATOMY = [
  { name: "Lành tính", value: 1 },
  { name: "Nghi ngờ", value: 2 },
  { name: "Ác tính", value: 3 },
];

export const DEATH_BY = [
  { name: "Bệnh", value: 1 },
  { name: "Tai biến", value: 2 },
  { name: "Khác", value: 3 },
];

export const SYNTHETIC_MEDICAL_REQUEST_STORE = [
  { name: "Chưa tổng hợp", value: false },
  { name: "Tổng hợp", value: true },
];

export const TYPE_ROOM_DEFAULT = [
  {
    value: "defaultClinicRoom",
    prod: "examination",
    name: "Phòng khám tổng quát",
  },
  {
    value: "defaultVisualAcuityTestingRoom",
    prod: "",
    name: "Phòng đo thị lực",
  },
  { value: "defaultTreatmentRoom", prod: "", name: "Phòng điều trị" },
  { value: "defaultLaboratoryRoom", prod: "LabTest", name: "Phòng xét nghiệm" },
  {
    value: "defaultImagingDiagnosticsRoom",
    prod: "diagnostic_imaging",
    name: "Phòng chẩn đoán hình ảnh",
  },
  { value: "defaultReceptionRoom", prod: "", name: "Phòng tiếp đón" },
  {
    value: "defaultProcedureRoom",
    prod: "Procedures",
    name: "Phòng thủ thuật",
  },
  { value: "defaultPatientRoom", prod: "", name: "Phòng bệnh" },
  { value: "defaultOperatingRoom", prod: "", name: "Phòng phẫu thuật" },
  { value: "defaultAccountingOffice", prod: "", name: "Phòng kế toán" },
  { value: "defaultRefractionRoom", prod: "", name: "Phòng đo khúc xạ" },
  { value: "defaultConsultationRoom", prod: "", name: "Phòng tư vấn" },
];

export const STATUS_STORE_REQUEST = {
  REJECT: -1,
  NEW: 0,
  CONFIRM: 1,
  COMPLETE: 2,
};

export const OPTION_EPISODE_OF_CARE_TYPE = [
  {
    name: "Ngoại trú",
    value: 1,
  },
  {
    name: "Nội trú",
    value: 2,
  },
];

export const LIST_SERVICE_TYPE_CODE = [
  "diagnostic_imaging",
  "LabTest",
  "other_service",
  "function_probe",
  "Procedures",
];
export const LIST_SERVICE_TYPE_CODE_ADD_BED = [
  "diagnostic_imaging",
  "LabTest",
  "bedridden_service",
  "Day_bed_daytime",
  "Bed_date_saved",
  "bedridden_service1",
  "other_service",
  "function_probe",
];
export const POSITION_CODE_RECEIVE = "TD";

export const SOURCE_CODE_BHYT = "BH";

export const VOUCHER_TYPE = [
  { name: "Chi tiền", value: VOUCHER_TYPE_VALUE.Paid },
  { name: "Thu tiền", value: VOUCHER_TYPE_VALUE.Receive },
];

export const SERVICE_NAME = [
  { name: "Khám bệnh: ", value: "examinationCosts", subtitle: "" },
  { name: "Ngày giường: ", value: "", subtitle: "" },
  {
    name: "Ngày giường điều trị ban ngày: ",
    value: "dayDayTreatmentBeds",
    subtitle: "",
  },
  {
    name: "Ngày giường điều trị nội trú: ",
    value: "inpatientBeds",
    subtitle: "",
  },
  {
    name: "Ngày giường lưu: ",
    value: "bedDaysStay",
    subtitle:
      "Áp dụng đối với Phòng khám đa khoa khu vực và Trạm y tế tuyến xã",
  },
  { name: "Xét nghiệm: ", value: "tests", subtitle: "" },
  { name: "Chẩn đoán hình ảnh: ", value: "imgStudys", subtitle: "" },
  { name: "Thăm dò chức năng: ", value: "functionProbes", subtitle: "" },
  {
    name: "Thủ thuật, phẫu thuật: ",
    value: "surgerysProcedures",
    subtitle: "",
  },
  {
    name: "Máu, chế phẩm máu, vận chuyển máu: ",
    value: "bloods",
    subtitle: "",
  },
  { name: "Thuốc, dịch truyền: ", value: "drugs", subtitle: "" },
  {
    name: "Vật tư y tế:",
    value: "medicalSupplys",
    subtitle:
      "Vật tư y tế chưa bao gồm với dịch vụ kỹ thuật nào, Ví dụ: Bơm cho ăn 50ml, dây truyền dịch...",
  },
  {
    name: "Gói vật tư y tế: ",
    value: "",
    subtitle:
      "Các vật tư y tế đi kèm trong một lần thực hiện dịch vụ kỹ thuật, không ghi các vật tư y tế đã tính kết cấu trong giá dịch vụ kỹ thuật đó",
  },
  {
    name: "Gói vật tư y tế 1: ",
    value: "medicalSupplySets",
    subtitle: "Ghi kèm theo tên dịch vụ kỹ thuật thực hiện",
  },
  { name: "Gói vật tư y tế 2: ", value: "medicalSupplySets", subtitle: "" },
  {
    name: "Vận chuyển người bệnh:",
    value: "transportingPatients",
    subtitle: "",
  },
  { name: "Dịch vụ khác:", value: "otherServices", subtitle: "" },
];

export const totalFieldsVoucher = [
  "totalOfVoucherByCash",
  "totalOfVoucherByTapCard",
  "totalOfVoucherByBankTranfer",
  "totalOfVoucherByGuaranteedDebt",
  "totalOfVoucherByAccountsReceivable",
  "totalOfVoucherByOther",
];

export const PACKAGE_TYPE = [
  { name: "Khám đoàn", value: 1 },
  { name: "Chỉ định nhanh", value: 2 },
];
export const REPORT_DATE_TYPE = [
  { name: "Ngày khám", value: 1 },
  { name: "Ngày vào viện", value: 2 },
  { name: "Ngày ra viện", value: 3 },
  { name: "Ngày thanh toán", value: 4 },
];

export const TYPE_SERVICE = [
  { name: "BHYT", value: 1 },
  { name: "Dịch vụ", value: 2 },
  { name: "Cả 2", value: 3 },
];

export const TYPE_ORDER_DRUG = [
  { name: "Thuốc kê BHYT", value: 1 },
  { name: "Thuốc kê dịch vụ", value: 2 },
  { name: "Thuốc kê ngoài", value: 3 },
];

export const TRANSACTION_STATUS_NEW = 0;
export const TRANSACTION_STATUS_CONFIRMED = 2;
export const TRANSACTION_STATUS_PREPARE = 1;

export const TRANSACTION_STATUS = [
  { value: TRANSACTION_STATUS_NEW, name: "Chờ xác nhận" },
  { value: TRANSACTION_STATUS_CONFIRMED, name: "Đã xác nhận" },
  { value: -1, name: "Đã hủy" },
];

export const LIST_PAYMENT_SEACH_STATUS = [
  { value: 1, name: "Đã thu đủ tiền" },
  { value: 2, name: "Cần hoàn tiền" },
  { value: 3, name: "Cần thu thêm" },
  // { value: 4, name: "Chưa thu tiền" },
];
// {
//     value: 1,
//     name: "Chờ xác nhận",
//     icon: <Brightness1 style={{ color: "#f03030" }} />,
//     color: "#fff",
//     bgColor: "green",
//     className: "appointment-status-waiting",
//   },
export const APPOINTMENT_STATUS = [
  {
    value: 1,
    name: "Chờ xác nhận",
    icon: <Brightness1 style={{ color: "orange" }} />,
    color: "#fff",
    bgColor: "#fbedc1",
    className: "appointment-status-waiting",
  },
  {
    value: 2,
    name: "Đã xác nhận",
    icon: <Brightness1 style={{ color: "#66CC66" }} />,
    color: "#fff",
    bgColor: "#fbedc1",
    className: "appointment-status-accept",
  },
  {
    value: 3,
    name: "Đã hủy",
    icon: <Brightness1 style={{ color: "#ccc" }} />,
    color: "#fff",
    bgColor: "#ff8100",
    className: "appointment-status-cancel",
  },
  {
    value: 4,
    name: "Đã đến",
    icon: <Brightness1 style={{ color: "blue" }} />,
    color: "#fff",
    bgColor: "#e0b2ff",
    className: "appointment-status-finish",
  },
  {
    value: 6,
    name: "Không đến",
    icon: <Brightness1 style={{ color: "blue" }} />,
    color: "#fff",
    bgColor: "#f5c6cb",
    className: "appointment-status-not-come",
  },
];

export const LIST_SERVICE_ROOM_TYPE = [
  { value: "normal", name: "Phòng thường" },
  { value: "vip", name: "Phòng VIP" },
];

export const APPOINTMENT_STAGES = [
  { name: "Tạo lịch", value: 1, nameStaff: "Người tạo lịch hẹn" },
  { name: "Xác nhận lịch", value: 2, nameStaff: "Người xác nhận lịch hẹn" },
  { name: "Đã tiếp đón BN/KH", value: 3, nameStaff: "Người tiếp đón" },
  { name: "Bắt đầu đợt/liệu trình", value: 4, nameStaff: "Người bắt đầu đợt" },
  { name: "Bắt đầu khám", value: 5, nameStaff: "Người khám" },
  { name: "Kết thúc khám", value: 6, nameStaff: "Người kt khám" },
  {
    name: "Kết thúc liệu trình",
    value: 7,
    nameStaff: "Người kết thúc liệu trình",
  },
];

export const SEND_NOTI_TYPE = [
  { name: "SMS", value: 1 },
  { name: "Zalo", value: 2 },
];

export const CUSTOMER_TICKET_STATUS_WAITING = 1;
export const CUSTOMER_TICKET_STATUS_PROCESSING = 2;
export const CUSTOMER_TICKET_STATUS_PROCESSED = 3;
export const CUSTOMER_TICKET_STATUS = [
  { name: "Đang chờ xử lý", value: CUSTOMER_TICKET_STATUS_WAITING },
  { name: "Đang xử lý", value: CUSTOMER_TICKET_STATUS_PROCESSING },
  { name: "Đã xử lý", value: CUSTOMER_TICKET_STATUS_PROCESSED },
];
export const TRANSACTION_TYPE_IMPORT = 1;
export const TRANSACTION_TYPE_EXPORT = -1;
export const ListStoreTransactionType = [
  { name: "Nhập kho", value: TRANSACTION_TYPE_IMPORT },
  { name: "Xuất kho", value: TRANSACTION_TYPE_EXPORT },
];

export const STORE_REQUEST_HANDLE_TYPE_CUSTOMER = 2;
export const STORE_REQUEST_HANDLE_TYPE = [
  { value: 1, name: "Xuất tổng hợp theo theo khoa, phòng" },
  {
    value: STORE_REQUEST_HANDLE_TYPE_CUSTOMER,
    name: "Xuất theo từng khách hàng",
  },
];

export const TRANSTYPE_VALUE = {
  COMPENSATION_CABINET: -5, //xuất bù tủ trực
  EXPORT_ADDITIONAL_CABINET: -4, //xuất bổ sung cơ số tủ trực
  EXPORT_RETURN_CABINET: -12, //Xuất hoàn trả cơ số
  EXPORT_USED: -13, //Xuất sử dụng
  EXPORT_BY_RECEIPT: -6, //xuất thuốc theo phiếu lĩnh
  EXPORT_SALE: -9, //xuất bán
  EXPORT_RETURN_SUPPLIER: -1, //Xuất trả hàng nhà cung cấp
  EXPORT_TRANSFER_STORE_PRIMARY: -2, //Xuất điều chuyển  kho chính tới kho lẻ
  EXPORT_TRANSFER_STORE_SECONDARY: -3, //Xuất điều chuyển giữa các kho lẻ
  EXPORT_MEDICINE_DISPENSING: -7, //Xuất thuốc ngoại trú,
  EXPORT_TRANSFER_STORE_MEDICINE: -8, //Xuất chuyển kho giữa các nhà thuốc
  EXPORT_SALES: -9, //Xuất bán,
  EXPORT_WASTAGE_DEPARTMENT: -10, //Xuất hao phí   khoa phòng
  EXPORT_DESTROY: -11, //Xuất hủy

  IMPORT_RESTOCK: 9, // nhập lại từ khách hàng
  IMPORT_SUPPLIER: 1, // nhập mua
  IMPORT_MAIN_TO_RETAIL: 2, // nhập kho chính tới kho lẻ
  IMPORT_BETWEEN_RETAIL: 3, // nhập điều chuyển giữa các kho lẻ
  IMPORT_ADDITIONAL_CABINET: 4, // nhập bổ sung cơ số tủ trực
  IMPORT_COMPENSATION_CABINET: 5, // nhập bù tủ trực
  IMPORT_BETWEEN_PHARMACIES: 8, // nhập điều chuyển giữa các nhà thuốc
  IMPORT_REFUND_CABINET: 12, // nhập hoàn trả cơ số tủ trực
  IMPORT_BY_RECEIPT: 6, // nhập thuốc theo phiếu lĩnh
  IMPORT_OUTPATIENT_RESTOCK: 7, // nhập thuốc hoàn trả theo BN ngoại trú
  IMPORT_BEGINNING_INVENTORY: 100, // nhập tồn đầu kỳ
};

export const STORE_REQUEST_TYPE_INDIVIDUAL = 1; // ca nhan
export const STORE_REQUEST_TYPE_GENERAL = 2; // tong hop

export const STORE_REQUEST_TYPE = [
  { value: STORE_REQUEST_TYPE_INDIVIDUAL, name: "Cá nhân" },
  { value: STORE_REQUEST_TYPE_GENERAL, name: "Tổng hợp" },
];

export const CUSTOMER_SEND = 1; //KH send
export const STAFF_SEND = 2; //NV
export const CONSUMABELS = "CONSUMABELS"; //Vật tư tiêu hao

export const ENCOUNTER_STATUS_SERVICE = [
  {
    name: "Mới",
    value: ENCOUNTER_NEW,
    icon: <AccountCircle style={{ color: "#0076ff" }} />,
  },
  {
    name: "Đang khám",
    value: 2,
    icon: <AccountBox style={{ color: "#ff8100" }} />,
  },
  {
    name: "Đã kết thúc",
    value: ENCOUNTER_END,
    icon: <HowToReg style={{ color: "green" }} />,
    bgColor: "#ff0606",
    color: "#fff",
  },
];

export const GENUS_TYPE = 1;
export const RECEIVER_TYPE = 2;
export const ENTRY_TYPES = [
  { value: RECEIVER_TYPE, name: "Loại thu" },
  { value: GENUS_TYPE, name: "Loại chi" },
];

export const SOURCE_SERVICE_CODE = "DV";
export const TRANSTYPE_BEGINNING_VALUE = 100;
export const TransactionStatus = {
  WAIT_CONFIRM: 0,
  PREPARED: 1,
  CONFIRMED: 2,
};
export const TYPE_PRINT_FORM_EXPORT = 1; //phieu xuat kho
export const TYPE_PRINT_FORM_RETURN = 2; //phieu trả lại
export const TYPE_PRINT_FORM_RECEIPT = 3; //phieu linh

export const TYPE_PRINT_FORM = [
  {
    label: "Phiếu xuất",
    value: TYPE_PRINT_FORM_EXPORT,
  },
  {
    label: "Phiếu trả lại",
    value: TYPE_PRINT_FORM_RETURN,
  },
  {
    label: "Phiếu lĩnh",
    value: TYPE_PRINT_FORM_RECEIPT,
  },
];

export const CODE_STORE_EMERGENCY = "TT12";
export const STATEMENT_LIST = [
  { value: 0, name: "Bảng kê tổng hợp" },
  { value: 1, name: "Bảng kê bảo hiểm" },
];

export const VALUE_SYNTHETIC = 4;
export const VALUE_CONSUMABLES = 7;
export const TYPE_SUPPLY = [
  { value: VALUE_SYNTHETIC, name: "SYNTHETIC" },
  { value: VALUE_CONSUMABLES, name: "CONSUMABLES" },
];

export const TAB_LIST_DRUG = [
  { tabName: "Thuốc dịch vụ", value: 0, nameSpace: "serviceMediRequest" },
  { tabName: "Thuốc ngoài", value: 1, nameSpace: "otherMediRequest" },
];

export const TAB_LIST_DRUG_SENDHI_PRICE = [
  { tabName: "Thuốc bảo hiểm", value: 0, nameSpace: "isuranceMediRequest" },
  { tabName: "Thuốc dịch vụ", value: 1, nameSpace: "serviceMediRequest" },
  { tabName: "Thuốc ngoài", value: 2, nameSpace: "otherMediRequest" },
];

export const REVENUE_TYPE = [
  { name: "Nhà thuốc", value: 1 },
  { name: "Tổng", value: 2 },
  { name: "Khám chữa bệnh", value: 3 },
];

export const ROUND_DOWN_HOSPITAL_LIST = [
  { name: "Làm tròn xuống", value: 0 },
  { name: "Làm tròn lên", value: 1 },
  { name: "Làm tròn gần nhất", value: 2 },
];

export const TYPE_MEDICINE = [
  {
    value: 1,
    name: "Thuốc BHYT",
  },
  {
    value: 2,
    name: "Thuốc DV",
  },
  {
    value: 4,
    name: "Vật tư y tế",
  },
  {
    value: 5,
    name: "Thuốc Ngoài",
  },
  {
    value: 7,
    name: "Vật tư tiêu hao",
  },
];

export const CUSTOMER_CARD_STATUS = [
  {
    value: 0,
    name: "Chưa kích hoạt",
  },
  {
    value: 1,
    name: "Đã kích hoạt",
  },
  {
    value: 2,
    name: "Đã hết hiệu lực",
  },
  {
    value: 3,
    name: "Đã khóa",
  },
];

export const CUSTOMER_CARD_TYPE = [
  {
    value: 0,
    name: "Thẻ vip",
  },
  {
    value: 1,
    name: "Thẻ thường",
  },
  {
    value: 2,
    name: "Thẻ bạc",
  },
];

export const TYPE_EXAMINATION = [
  { value: "1", name: "Dịch vụ" },
  { value: "2", name: "Bảo hiểm" },
];

export const VEHICLE_CLASS_V2 = [
  { value: "A1", name: "A1" },
  { value: "B1", name: "B1" },
  { value: "A", name: "A" },
  { value: "B", name: "B" },
  { value: "C1", name: "C1" },
  { value: "C", name: "C" },
  { value: "D1", name: "D1" },
  { value: "D2", name: "D2" },
  { value: "D", name: "D" },
  { value: "BE", name: "BE" },
  { value: "CE", name: "CE" },
  { value: "C1E", name: "C1E" },
  { value: "D1E", name: "D1E" },
  { value: "D2E", name: "D2E" },
  { value: "DE", name: "DE" },
];

export const LIST_FAMILY = [
  {
    fieldName1: "diseaseInPastFiveYearsFamily",
    name1: "Có bệnh hay bị thương trong 5 năm qua",
    index1: 1,
    fieldName2: "diabetesFamily",
    name2: "Đái tháo đường hoặc kiểm soát tăng đường huyết",
    index2: 12,
  },
  {
    fieldName1: "neurologicalHeadDiseaseFamily",
    name1: "Có bệnh thần kinh hay bị thương ở đầu",
    index1: 2,
    fieldName2: "mentalIllnessFamily",
    name2: "Bệnh tâm thần",
    index2: 13,
  },
  {
    fieldName1: "hypertensionFamily",
    name1: "Bệnh mắt hoặc giảm thị lực (trừ trường hợp đeo kính thuốc)",
    index1: 3,
    fieldName2: "lossConsciousnessFamily",
    name2: "Mất ý thức, rối loạn ý thức",
    index2: 14,
  },
  {
    fieldName1: "eyeDiseaseFamily",
    name1: "Bệnh ở tai, giảm sức nghe hoặc thăng bằng",
    index1: 4,
    fieldName2: "faintingDizzinessFamily",
    name2: "Ngất, chóng mặt",
    index2: 15,
  },
  {
    fieldName1: "earDiseaseFamily",
    name1: "Bệnh ở tim, hoặc nhồi máu cơ tim, các bệnh tim mạch khác",
    index1: 5,
    fieldName2: "gastrointestinalDiseasesFamily",
    name2: "Bệnh tiêu hóa",
    index2: 16,
  },
  {
    fieldName1: "heartDiseaseFamily",
    name1:
      "Phẫu thuật can thiệp tim - mạch (thay van, bắc cầu nối, tạo hình mạch, máy tạo nhịp, đặt slent mạch, ghép tim)",
    index1: 6,
    fieldName2: "sleepDisordersFamily",
    name2: "Rối loạn giấc ngủ, ngừng thở khi ngủ, ngủ rũ ban ngày, ngáy to",
    index2: 17,
  },
  {
    fieldName1: "cardiovascularSurgeryFamily",
    name1: "Tăng huyết áp",
    index1: 7,
    fieldName2: "strokeParalysisFamily",
    name2: "Tai biến mạch máu não hoặc liệt",
    index2: 18,
  },
  {
    fieldName1: "dyspneaFamily",
    name1: "Khó thở",
    index1: 8,
    fieldName2: "spinalDiseaseFamily",
    name2: "Bệnh hoặc tổn thương cột sống",
    index2: 19,
  },
  {
    fieldName1: "lungsDiseaseFamily",
    name1: "Bệnh phổi, hen, khí phế thũng, viêm phế quản mạn tính",
    index1: 9,
    fieldName2: "usuallyDrinkAlcoholFamily",
    name2: "Sử dụng rượu thường xuyên, liên tục",
    index2: 20,
  },
  {
    fieldName1: "kidneyDiseaseFamily",
    name1: "Bệnh thận, lọc máu",
    index1: 10,
    fieldName2: "drugSubstanceAbuseFamily",
    name2: "Sử dụng ma túy và chất gây nghiện",
    index2: 21,
  },
  {
    fieldName1: "alcoholAddictionFamily",
    name1: "Nghiện rượu, bia",
    index1: 11,
    fieldName2: "otherDiseasesFamilyCheck",
    name2: "Bệnh khác (ghi rõ)",
    index2: 22,
    fieldName3: "otherDiseasesFamily",
    name3: "null",
    index3: 23,
  },
];

export const ADVISE_STATUS = [
  // { name: "Chưa tư vấn", value: 0 },
  // { name: "Đang khám", value: 1 },
  // { name: "Đã kết thúc", value: 2 },
  { name: "Đã soát kết quả", value: 5 },
  { name: "Đã tư vấn", value: 6 },
];

export const TEXT_NORMAL = "bình thường";

export const HttpStatus = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
};

export const CONCLUDE_CAMPAIGN = [
  { value: "LOẠI I", name: "LOẠI I" },
  { value: "LOẠI II", name: "LOẠI II" },
  { value: "LOẠI III", name: "LOẠI III" },
  { value: "LOẠI IV", name: "LOẠI IV" },
  { value: "LOẠI V", name: "LOẠI V" },
  { value: "CHƯA PHÂN LOẠI", name: "CHƯA PHÂN LOẠI" },
];

export const TAB_LIST_CAMPAIGN = [
  { tabName: "Danh sách chờ lấy mẫu", value: 1 },
  { tabName: "Danh sách đã lấy mẫu", value: 2 },
  { tabName: "Danh sách đã thực hiện", value: 4 },
  { tabName: "Danh sách đã trả kết quả", value: 6 },
  { tabName: "Tất cả", value: null },
];

export const GROUP_SERVICE_CAMPAIGN = [
  { name: "Dịch Vụ Siêu Âm", value: "DVSA" },
  { name: "Dịch Vụ Thăm Dò Chức Năng", value: "DVTDCN" },
  { name: "Dịch Vụ X-Quang", value: "DVXQ" },
];

export const GET_SAMPLE_OPTION_DEFAULT = [
  { name: "Đạt", value: "Đạt" },
  { name: "Huyết tương đục nhẹ", value: "Huyết tương đục nhẹ" },
  { name: "Huyết tương đục", value: "Huyết tương đục" },
  { name: "Mẫu vỡ hồng cầu", value: "Mẫu vỡ hồng cầu" },
];
export const PRINT_NAME_COMPANY_OPYIONS = [
  { value: 1, name: "Có" },
  { value: 0, name: "Không" },
];

export const TEST_RESULT_PRINT = "TEST_RESULT_PRINT";
export const FEE_VOUCHER_PRINT_HEADER_MODE = "FEE_VOUCHER_PRINT_HEADER_MODE";
export const FEE_VOUCHER_LEGAL_ENTITY_BY_DEPT =
  "FEE_VOUCHER_LEGAL_ENTITY_BY_DEPT";
export const FEE_VOUCHER_PRINT_HEADER_MODE_DEPARTMENT = "department";
export const FEE_VOUCHER_PRINT_HEADER_MODE_LEGAL_ENTITY = "legal_entity";

export const SCOPE_TYPE = [
  { name: "Phạm vi sản phẩm", value: 0 },
  { name: "Phạm vi dịch vụ", value: 1 },
];

export const SERVICE_GROUP_SCOPE = [
  { name: "Dịch vụ", value: 1 },
  { name: "Gói dịch vụ", value: 2 },
  { name: "Tất cả", value: 3 },
];

export const PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT = 1;
export const PAYMENT_METHOD_CHARACTERISTIC_DEDUCT_FROM_DEPOSIT = 2;
export const PAYMENT_METHOD_CHARACTERISTIC_DEDUCT_FROM_OLD_TREATMENT = 3;
export const PAYMENT_METHOD_CHARACTERISTIC_USE_PREPAID_CARD = 4;
export const PAYMENT_METHOD_CHARACTERISTIC_POS = 5;
export const PAYMENT_METHOD_CHARACTERISTIC_HOME_CREDIT = 6;
export const PAYMENT_METHOD_CHARACTERISTIC_POS_VNPAY_TRAGOP = 7;
export const PAYMENT_METHOD_CHARACTERISTIC_PENDING_PAYMENT_CODE = "CC";
export const PAYMENT_METHOD_CHARACTERISTIC_CASH_CODE = "TM";
export const PAYMENT_METHOD_CHARACTERISTIC_HOME_CREDIT_CODE = "HOME_CREDIT";
export const PAYMENT_METHOD_CHARACTERISTIC_POS_VNPAY_TRAGOP_CODE =
  "POS_VNPAY_TRAGOP";

// Khấu trừ tiền LT cũ
export const PAYMENT_METHOD_CHARACTERISTIC_TREATMENT_PLANTCARD_CODE =
  "KHAU_TRU";
export const PAYMENT_METHOD_CHARACTERISTIC_LOYALTY = "DUNG_DIEM";

export const PAYMENT_METHOD_CHARACTERISTIC = [
  {
    name: "Cần chọn STK nhận tiền",
    value: PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT,
  },
  {
    name: "Trừ tiền cọc",
    value: PAYMENT_METHOD_CHARACTERISTIC_DEDUCT_FROM_DEPOSIT,
  },
  {
    name: "Chọn máy POS",
    value: PAYMENT_METHOD_CHARACTERISTIC_POS,
  },
  {
    name: "Dùng thẻ trả trước",
    value: PAYMENT_METHOD_CHARACTERISTIC_USE_PREPAID_CARD,
  },
  {
    name: "Chờ chi",
    value: PAYMENT_METHOD_CHARACTERISTIC_PENDING_PAYMENT_CODE,
  },
  {
    name: "Chọn máy POS_VNPAY_TRAGOP",
    value: PAYMENT_METHOD_CHARACTERISTIC_POS_VNPAY_TRAGOP,
  },
  {
    name: "Chọn HOME_CREDIT",
    value: PAYMENT_METHOD_CHARACTERISTIC_HOME_CREDIT,
  },
];

export const CARD_PATIENT_STATUS = [
  {
    value: 0,
    name: "Còn hiệu lực",
  },
  {
    value: -1,
    name: "Hết hiệu lực",
  },
];
export const CLIENT_CARD_STATUS = [
  {
    value: 0,
    name: "Chưa kích hoạt",
  },
  {
    value: 1,
    name: "Đã kích hoạt",
  },
  {
    value: 2,
    name: "Đã hết hiệu lực",
  },
  {
    value: 3,
    name: "Đã khóa",
  },
];

export const CLIENT_CARD_SCOPE_TYPE_SERVICE = 1; // dịch vụ
export const CLIENT_CARD_SCOPE_TYPE_PRODUCT = 2; // sản phẩm
export const CLIENT_CARD_SCOPE_TYPE_MEDICAL = 3; // sản phẩm
export const CLIENT_CARD_SCOPE_TYPE_PRODUCT_GROUP = 4; // nhóm sản phẩm
export const CLIENT_CARD_SCOPE_TYPE_SERVICE_GROUP = 5; // nhóm dịch vụ

export const CLIENT_CARD_SCOPE_TYPE = [
  {
    value: CLIENT_CARD_SCOPE_TYPE_SERVICE,
    name: "Dịch vụ",
  },
  {
    value: CLIENT_CARD_SCOPE_TYPE_PRODUCT,
    name: "Sản phẩm",
  },
  {
    value: CLIENT_CARD_SCOPE_TYPE_MEDICAL,
    name: "Vật tư",
  },
];

export const PATIENT_TYPE_SERVICE_USING_CARD = "9"; // đối tượng kh thẻ

export const ISUSING = [
  { name: "Có", value: true },
  { name: "Không", value: false },
];

export const VAT_INCLUDED = [
  { name: "Có", value: true },
  { name: "Không", value: false },
];

export const TYPE_CARD = [
  { name: "thẻ trả trước", value: 1 },
  { name: "thẻ liệu trình", value: 2 },
];

export const STATUS_RESULT_PATIENT_ADVISE = [
  { value: 1, name: "Mới" },
  { value: 2, name: "Thành Công" },
  { value: 3, name: "Không Thành Công" },
  // { value: 4, name: "Đã chốt dịch vụ" },
  // { value: 5, name: "Đã chuyển điều trị" },
  // { value: 6, name: "Từ chối dịch vụ" },
  // { value: 7, name: "Kết thúc tư vấn" },
];
export const STATUS_PATIENT_ADVISE = [
  {
    name: "Mới",
    value: "new",
    icon: <Brightness1 style={{ color: "#4276a4" }} />,
  },
  {
    name: "Đã chỉnh sửa",
    value: "edited",
    icon: <Brightness1 style={{ color: "#FF9966" }} />,
  },
  {
    name: "Đã xóa",
    value: "deleted",

    icon: <Brightness1 style={{ color: "lightslategrey" }} />,
  },
];

export const PATIENT_TYPE_SERVICE = [
  { name: "Đối tượng khách hàng", value: 1 },
  { name: "Loại giá", value: 2 },
];

export const LINHANH_ACTIVITY_LOG_TYPE = [
  { name: "Chỉnh sửa tư vấn", value: 1 },
  { name: "Xóa tư vấn", value: 2 },
  { name: "Hủy check-in", value: 3 },
  { name: "Request tới hệ thống CRM", value: 4 },
  { name: "Xóa chỉ định dịch vụ", value: 5 },
  { name: "Cập nhật phiếu thu", value: 6 },
  { name: "Hủy hóa đơn", value: 7 },
  { name: "Request tới hệ thống Store", value: 8 },
  { name: "Lưu hóa đơn và cập nhật sang CRM", value: 9 },
  { name: "CRM đồng bộ sang HIS", value: 11 },
];

export const APPOINTMENT_TYPE_CONSULT = 1;
export const APPOINTMENT_TYPE_TREATMENT = 2;

export const APPOINTMENT_TYPE = [
  { name: "Tư vấn", value: APPOINTMENT_TYPE_CONSULT },
  { name: "Điều trị", value: APPOINTMENT_TYPE_TREATMENT },
];

export const DATA_TYPE = [
  { name: "DL cũ (đồng bộ HT cũ)", value: 1 },
  { name: "DL mới", value: 2 },
];

export const RANK_LIST = [
  {
    code: "TX",
    class: "rank-basic",
    color: "#219d77",
  },
  {
    code: "RR",
    class: "rank-ruby",
    color: "#b3001b",
  },
  {
    code: "HM",
    class: "rank-gold",
    color: "#8c6b00",
  },
  {
    code: "VM",
    class: "rank-royal",
    color: "#5c49a5",
  },
];

export const ABSTRACT_PRODUCT = [
  { name: "Sản phẩm", value: 1 },
  { name: "Vật Tư", value: 2 },
  { name: "Trang Thiết Bị", value: 3 },
];

export const SEARCH_TYPE_APPOINTMENT = [
  { name: "Tìm theo SĐT", value: 1 },
  { name: "Tìm theo Mã KH", value: 2 },
];

export const TIME_FRAME = [
  {
    name: "90",
    value: "90",
  },
  {
    name: "120",
    value: "120",
  },
  {
    name: "180",
    value: "180",
  },
  {
    name: "200",
    value: "200",
  },
  {
    name: "300",
    value: "300",
  },
  {
    name: "360",
    value: "360",
  },
  {
    name: "420",
    value: "420",
  },
  {
    name: "480",
    value: "480",
  },
];

export const PAYMENT_METHOD_SELECT = [
  { name: "Thanh toán hết", value: 1 },
  { name: "Thanh toán 1 phần", value: 2 },
];

export const FORM_PRINT_THERMAL = 1;
export const FORM_PRINT_THERMAL_SYNTHETIC = 2;
export const FORM_PRINT_A5_SYNTHETIC = 3;
export const FORM_PRINT_SERVICE_SINGLE = 4;
export const FORM_PRINT_A5_SERVICE_SINGLE = 5;
export const FORM_PRINT_A5 = 6;
export const FORM_PRINT_THERMAL_RECEIPT = 7;
export const FORM_PRINT_A5_RECEIPT = 8;
export const FORM_PRINT = [
  { value: FORM_PRINT_SERVICE_SINGLE, name: " Mẫu in nhiệt (In DVSP lẻ)" },
  { value: FORM_PRINT_THERMAL, name: "Mẫu in nhiệt - CT" },
  { value: FORM_PRINT_THERMAL_SYNTHETIC, name: "Mẫu in nhiệt (tổng hợp)" },
  { value: FORM_PRINT_A5_SYNTHETIC, name: "Mẫu in A5 (tổng hợp)" },
  { value: FORM_PRINT_A5_SERVICE_SINGLE, name: "Mẫu in A5 (In DVSP lẻ)" },
  { value: FORM_PRINT_A5, name: " Mẫu in A5 - CT" },
  { value: FORM_PRINT_THERMAL_RECEIPT, name: "In nhiệt (Phiếu thu - chi)" },
  { value: FORM_PRINT_A5_RECEIPT, name: "In A5 (Phiếu thu - chi)" },
];

export const FORM_PRINT_ADVANCE = [
  { value: FORM_PRINT_THERMAL, name: "Mẫu in nhiệt - CT" },
  { value: FORM_PRINT_A5, name: " Mẫu in A5 - CT" },
  { value: FORM_PRINT_THERMAL_RECEIPT, name: "In nhiệt (Phiếu thu)" },
  { value: FORM_PRINT_A5_RECEIPT, name: "In A5 (Phiếu thu)" },
];

export const TYPE_SERVICES = [
  {
    value: 2,
    name: "Loại đã chốt",
  },
  {
    value: 1,
    name: "Loại quan tâm",
  },
];

export const REGISTRATION_STATUS = [
  {
    value: 1,
    name: "Đã đăng ký",
    className: "registerd",
    char: "✓",
  },
  {
    value: 2,
    name: "Chưa đăng ký",
    className: "not-registerd",
    char: "",
  },
];
export const TYPE_CUSTOMER_JOURNEY_VALUE = {
  CreateLead: 1,
  Calllog: 2,
  CreateAppointment: 3,
  Receptioned: 4,
  BuyService: 5,
  Payment: 6,
  Checkout: 7,
  Reaction: 8,
};

export const TYPE_CUSTOMER_JOURNEY = [
  { name: "Tạo lead", value: TYPE_CUSTOMER_JOURNEY_VALUE.CreateLead },
  { name: "Tương tác KH (gọi)", value: TYPE_CUSTOMER_JOURNEY_VALUE.Calllog },
  {
    name: "Tạo lịch (Đặt lịch)",
    value: TYPE_CUSTOMER_JOURNEY_VALUE.CreateAppointment,
  },
  {
    name: "Tiếp đón BN (checkin)",
    value: TYPE_CUSTOMER_JOURNEY_VALUE.Receptioned,
  },
  { name: "Mua sp,dv", value: TYPE_CUSTOMER_JOURNEY_VALUE.BuyService },
  { name: "Thanh toán", value: TYPE_CUSTOMER_JOURNEY_VALUE.Payment },
  { name: "Checkout", value: TYPE_CUSTOMER_JOURNEY_VALUE.Checkout },
  { name: "Tương tác", value: TYPE_CUSTOMER_JOURNEY_VALUE.Reaction },
];

// concept
export const CONCEPT_BODY = [
  { name: "Vùng Đầu", value: "HEAD" },
  { name: "Vùng Vai Cổ Gáy", value: "NECK_SHOULDER" },
  { name: "Bả Vai Phải", value: "SHOULDER_RIGHT" },
  { name: "Bả Vai Trái", value: "SHOULDER_LEFT" },
  { name: "Tay Phải", value: "ARM_RIGHT" },
  { name: "Tay Trái", value: "ARM_LEFT" },
  { name: "Vùng Lưng", value: "BACK" },
  { name: "Vùng Ngực", value: "CHEST" },

  // Nhóm: Vùng Cơ Thể Giữa
  { name: "Vùng Eo", value: "WAIST" },
  { name: "Thắt Lưng", value: "LOWER_BACK" },
  { name: "Vùng Bụng", value: "ABDOMEN" },
  { name: "Vùng Mông", value: "BUTTOCK" },
  { name: "Vùng Bẹn", value: "GROIN" },
  { name: "Phụ Khoa", value: "GYNECOLOGY" },

  // Nhóm: Vùng Chân
  { name: "Đùi Phải", value: "THIGH_RIGHT" },
  { name: "Đùi Trái", value: "THIGH_LEFT" },
  { name: "Chân Phải", value: "LEG_RIGHT" },
  { name: "Chân Trái", value: "LEG_LEFT" },
];

// valueCoded: "SKIN_WHITENING"
export const CONCEPT_ANS_TREATMENT_BODY = [
  { name: "Tắm trắng", value: "SKIN_WHITENING" },
  { name: "Triệt lông", value: "HAIR_REMOVAL" },
  { name: "Giảm béo", value: "FAT_REDUCTION" },
];

// concept
export const CONCEPT_FACE = [
  { name: "Trán Phải", value: "FOREHEAD_RIGHT" },
  { name: "Trán Trái", value: "FOREHEAD_LEFT" },
  { name: "Thái Dương", value: "TEMPLE" },
  { name: "Mắt Phải", value: "EYE_RIGHT" },
  { name: "Mắt Trái", value: "EYE_LEFT" },
  { name: "Má Phải", value: "CHEEK_RIGHT" },
  { name: "Má Trái", value: "CHEEK_LEFT" },
  { name: "Mũi", value: "NOSE" },
  { name: "Tai Phải", value: "EAR_RIGHT" },
  { name: "Tai Trái", value: "EAR_LEFT" },
  { name: "Mép Phải", value: "LIP_CORNER_RIGHT" },
  { name: "Mép Trái", value: "LIP_CORNER_LEFT" },
  { name: "Nhân Trung", value: "PHILTRUM" },
  { name: "Cằm", value: "CHIN" },
  { name: "Cổ", value: "NECK" },
];

// valueCoded
export const CONCEPT_ANS_TREATMENT_FACE = [
  { name: "Giảm béo", value: "FAT_REDUCTION" },
  { name: "Điều trị mụn", value: "ACNE_TREATMENT" },
  { name: "Rối loạn sắc tố", value: "PIGMENT_DISORDER" },
  { name: "Điều trị sẹo rỗ", value: "SCAR_TREATMENT" },
];

export const CONCEPT_TYPE_CODE_VUNG = "VUNG";
export const CONCEPT_TYPE_CODE = [
  { name: "VÙNG", value: CONCEPT_TYPE_CODE_VUNG },
];

export const VOUCHER_INVOICE_HISTORY_DEPOSIT = 1;
export const VOUCHER_INVOICE_HISTORY_PREPAID_CARD = 2;
export const VOUCHER_INVOICE_HISTORY_TREATMENT_PLANCARD = 4;

export const VOUCHER_INVOICE_HISTORY__OTHER_PAYMENT_METHOD = 3;
export const VOUCHER_INVOICE_HISTORY_USE_POINT = 5;
export const VOUCHER_INVOICE_HISTORY_TYPE = [
  {
    value: VOUCHER_INVOICE_HISTORY_DEPOSIT,
    name: "Giao dịch liên quan đến tiền cọc",
  },
  {
    value: VOUCHER_INVOICE_HISTORY_PREPAID_CARD,
    name: "Giao dịch liên quan đến thẻ trả trước",
  },

  {
    value: VOUCHER_INVOICE_HISTORY__OTHER_PAYMENT_METHOD,
    name: "Các giao dịch khác liên quan đến thanh toán",
  },
  {
    value: VOUCHER_INVOICE_HISTORY_TREATMENT_PLANCARD,
    name: "Khấu trừ đơn hàng cũ",
  },
  {
    value: VOUCHER_INVOICE_HISTORY_USE_POINT,
    name: "Giao dịch dùng điểm",
  },
];
export const VOUCHER_INVOICE_HISTORY_DEDUCTION = [
  {
    value: VOUCHER_INVOICE_HISTORY_DEPOSIT,
    name: "Giao dịch liên quan đến tiền cọc",
  },
  {
    value: VOUCHER_INVOICE_HISTORY_PREPAID_CARD,
    name: "Giao dịch liên quan đến thẻ trả trước",
  },

  {
    value: VOUCHER_INVOICE_HISTORY_TREATMENT_PLANCARD,
    name: "Khấu trừ đơn hàng cũ",
  },
  {
    value: VOUCHER_INVOICE_HISTORY_USE_POINT,
    name: "Giao dịch dùng điểm",
  },
];
export const POINT_LEVEL = [
  { name: "VNĐ", value: 1 },
  { name: "lần", value: 2 },
];

export const RELATIONSHIP_TYPES = [
  { value: 1, name: "Bố mẹ" }, // Bố mẹ
  { value: 2, name: "Ông bà" }, // Ông bà
  { value: 3, name: "Vợ chồng" }, // Vợ chồng
  { value: 4, name: "Con cái" }, // Con cái
  { value: 5, name: "Cháu" }, // Cháu
  { value: 6, name: "Anh chị em" }, // Anh chị em
  { value: 7, name: "Cô/dì/chú/bác" }, // Cô/dì/chú/bác
  { value: 8, name: "Họ hàng" }, // Họ hàng
  { value: 9, name: "Bạn bè" }, // Bạn bè
  { value: 10, name: "Đồng nghiệp" }, // Đồng nghiệp
  { value: 11, name: "Sếp" }, // Sếp
  { value: 12, name: "Khách hàng" }, // Khách hàng
  { value: 13, name: "Khác" }, // Khác
];

export const ALLOCATION_UPON_REGISTRATION = 1;
export const ALLOCATION_UPON_PAYMENT = 2;

export const STAFF_REVENUE_TYPE = [
  { name: "Phân bổ khi đăng ký", value: ALLOCATION_UPON_REGISTRATION },
  { name: "Phân bổ khi thanh toán", value: ALLOCATION_UPON_PAYMENT },
];

export const STATUS_TREATMENT_LOCK = 2;

export const LEAD_SOURCE_LEVEL = Object.freeze({
  LEVEL_1: { value: 1, name: "Cấp 1" },
  LEVEL_2: { value: 2, name: "Cấp 2" },
  LEVEL_3: { value: 3, name: "Cấp 3" },
  getListData: function () {
    return Object.values(this).filter((type) => typeof type === "object");
  },
});

export const LOCK_STATUS_LOCKED_UPDATE = true;
export const LOCK_STATUS_UNLOCKED_UPDATE = false;

export const LOCK_STATUS_LOCKED_SEARCH = 1;
export const LOCK_STATUS_UNLOCKED_SEARCH = 2;
export const LOCK_STATUS_ALL = 3;

export const LOCK_STATUS_UPDATE = [
  { name: "Khóa", value: LOCK_STATUS_LOCKED_UPDATE },
  { name: "Chưa khóa", value: LOCK_STATUS_UNLOCKED_UPDATE },
];

export const LOCK_STATUS_SEARCH = [
  { name: "Khóa", value: LOCK_STATUS_LOCKED_SEARCH },
  { name: "Chưa khóa", value: LOCK_STATUS_UNLOCKED_SEARCH },
  { name: "Tất cả", value: LOCK_STATUS_ALL },
];

export const LOCK_STATUS_SEARCH_V2 = [
  { name: "Khóa", value: true },
  { name: "Chưa khóa", value: false },
];
export const LOCK_STATUS_REGISTER = 1;
export const LOCK_STATUS_PAYMENT = 2;

export const STAFF_REVENUE_TYPE_REPORT = [
  { name: "Loại doanh số", value: ALLOCATION_UPON_REGISTRATION },
  { name: "Loại doanh thu", value: ALLOCATION_UPON_PAYMENT },
];

export const TREATMENT_FREE = "LT_TUYCHINH";

export const PromotionTypeEnum = {
  DISCOUNT: { name: "Giảm giá theo % / số tiền", value: 0 },
  BUY_X_GET_Y: { name: "Mua X tặng Y", value: 1 },
  COMBO: { name: "Combo ưu đãi", value: 2 },
  FLASH_SALE: { name: "Flash Sale", value: 3 },
  BIRTHDAY: { name: "Sinh nhật khách", value: 4 },
  RETURN_AFTER_X_DAYS: { name: "Quay lại sau X ngày", value: 5 },
  REFERRAL: { name: "Giới thiệu bạn bè", value: 6 },
  PREPAY: { name: "Trả trước nhận ưu đãi", value: 7 },
  POINT_REWARD: { name: "Tặng điểm", value: 8 },
  LOTTERY: { name: "Dự thưởng / bốc thăm", value: 9 },
  REFERRER_REWARD: { name: "Ưu đãi giới thiệu", value: 10 },
  VOUCHER: { name: "Voucher", value: 11 },

  getListData() {
    return Object.keys(this)
      .filter(
        (key) =>
          typeof this[key] === "object" &&
          this[key] !== null &&
          "name" in this[key] &&
          "value" in this[key]
      )
      .map((key) => this[key]);
  },
};

export const DiscountTypeEnum = {
  DISCOUNT_PERCENT: { name: "Giảm theo phần trăm (%)", value: 0 },
  DISCOUNT_AMOUNT: { name: "Giảm theo số tiền (VNĐ)", value: 1 },

  getListData() {
    return Object.keys(this)
      .filter(
        (key) =>
          typeof this[key] === "object" &&
          this[key] !== null &&
          "name" in this[key] &&
          "value" in this[key]
      )
      .map((key) => this[key]);
  },
};

export const SYNC_TO_CRM_TRUE = true;
export const SYNC_TO_CRM_FALSE = false;

export const SYNC_TO_CRM = [
  { name: "Đã đồng bộ", value: SYNC_TO_CRM_TRUE },
  { name: "Chưa đồng bộ", value: SYNC_TO_CRM_FALSE },
];

export const COMPLAIN_STATUS_ACTIVE = 1;

export const COMPLAIN_STATUS = [
  // {
  //   value: 0,
  //   name: "Chưa từng có khiếu nại",
  //   icon: <Brightness1 style={{ color: "#66CC66" }} />,
  //   color: "#fff",
  //   bgColor: "#ff0000",
  //   className: "complain-status-none",
  // },
  {
    value: 1,
    name: "Đang có khiếu nại",
    icon: <Brightness1 style={{ color: "#ff0000" }} />,
    color: "#fff",
    bgColor: "#ff8100",
    className: "complain-status-new",
  },
  {
    value: 2,
    name: "Đã đóng khiếu nại",
    icon: <Brightness1 style={{ color: "blue" }} />,
    color: "#fff",
    bgColor: "#0076ff",
    className: "complain-status-closed",
  },
];

// 🔧 Gắn các hàm tiện ích vào chính object export
COMPLAIN_STATUS.getListData = function () {
  // có thể lọc hoặc clone để tránh thay đổi mảng gốc
  return [...this];
};

COMPLAIN_STATUS.fromValue = function (value) {
  return this.find((item) => item.value === value);
};

export const TOUR_STATUS = [
  { name: "Đã tích tour", value: true },
  { name: "Chưa tích tour", value: false },
];

export const CUSTOMER_JOURNEYS = [
  { value: 1, name: "Tạo lead" },
  { value: 2, name: "Gọi khách hàng" },
  { value: 3, name: "Tạo lịch (Đặt lịch)" },
  { value: 4, name: "Tiếp đón BN (checkin)" },
  { value: 5, name: "Mua sp, dv" },
  { value: 6, name: "Thanh toán" },
  { value: 7, name: "Checkout" },
  { value: 8, name: "Tương tác" },
];

export const DATE_TYPE_SUGGEST = [
  { value: 1, name: "Ngày chỉ định khác ngày thực hiện" },
  { value: 2, name: "Ngày chỉ định khác ngày hệ thống" },
  { value: 3, name: "Ngày thực hiện khác ngày hệ thống" },
];

export const SERVICE_PRODUCT_SOLUTION_CHANGE = 1; // Dừng và đổi liệu trình
export const SERVICE_PRODUCT_SOLUTION_REFUND = 2; // Dừng và hoàn tiền
export const SERVICE_PRODUCT_SOLUTION_LOCK = 3; // Người dùng khóa

export const SERVICE_PRODUCT_SOLUTION_OPTIONS = [
  { name: "Dừng và đổi liệu trình", value: SERVICE_PRODUCT_SOLUTION_CHANGE },
  { name: "Dừng và hoàn tiền", value: SERVICE_PRODUCT_SOLUTION_REFUND },
  { name: "Người dùng khóa", value: SERVICE_PRODUCT_SOLUTION_LOCK },
];

export const DATE_SORT_OPTIONS = [
  { name: "Tăng dần", value: false },
  { name: "Giảm dần", value: true },
];

export const DIRECTION_TYPE = [
  { name: "CRM_HIS", value: 0 },
  { name: "HIS_CRM", value: 1 },
  { name: "HIS_STORE", value: 3 },
];

export const HTTP_STATUS_CODE = [
  // { name: "Không có", value: 0 },
  { name: "Thành công", value: 1 },
  { name: "Thất bại", value: 2 },
];

export const TOAST_MESSAGE_HIS_TO_CRM = [
  { name: "Tìm được 2 client tương ứng phía CRM, đã merge", value: 1 },
  {
    name: "Chỉ tìm được client giữ lại phía crm, ko tìm được client cần bỏ đi phía crm",
    value: 2,
  },
  {
    name: "không tìm được Client giữ lại, chỉ tìm được bản ghi cần bỏ đi phía client",
    value: 3,
  },
  { name: "Có nhiều hơn 1 bản ghi cần xóa phía client, chưa merge", value: 4 },
  { name: "Tìm thấy nhiều hơn 1 client cần giữ lại phía CRM", value: 5 },
];
export const RESEND_STATUS = [
  { name: "Chưa gọi lại", value: 0 },
  { name: "Gọi lại thành công", value: 1 },
  { name: "Gọi lại thất bại", value: -1 },
];

export const HAS_IMG = [
  { name: "Đã up ảnh", value: true },
  { name: "Chưa up ảnh", value: false },
];

export const ACTIVE_STATUS = 1;
export const LOCKED_STATUS = 2;

export const LIST_ACTIVE_STATUS = [
  { name: "Có hiệu lực", value: ACTIVE_STATUS },
  { name: "Đã khóa", value: LOCKED_STATUS },
];
export const GENERAL_INFOMATION_TAB = 0;
export const APPOINTMENT_TAB = 1;
export const HISTORY_TAB = 2;
export const HISTORY_DIAGNOSIS_TAB = 3;
export const REGISTER_TREATMENT_TAB = 4;
export const REGISTER_CARD_TAB = 5;
export const ALL_SERVICES_TAB = 6;
export const REGISTER_PRODUCT_TAB = 7;
export const FEE_TAB = 8;
export const TREATMENT_TAB = 9;
export const CUSTOMER_JOURNEY_TAB = 10;
export const COMPLANT_TAB = 11;
export const REVIEW_TAB = 12;
export const IMAGE_TREATMENT_TAB = 13;
export const LOYALTY_TAB = 14;

export const DATE_UNIT_DAY = 1;
export const DATE_UNIT_MONTH = 2;
export const LIST_DATE_UNIT = [
  { name: "Ngày", value: DATE_UNIT_DAY },
  { name: "Tháng", value: DATE_UNIT_MONTH },
];

export const TransactionType = {
  Payment: -1,
  Receipt: 1,
};

export const DISCOUNT = 0;
export const BUY_X_GET_Y = 1;
export const COMBO = 2;
export const FLASH_SALE = 3;
export const BIRTHDAY = 4;
export const RETURN_AFTER_X_DAYS = 5;
export const REFERRAL_PROMOTION = 6;
export const PREPAY = 7;
export const POINT_REWARD = 8;
export const LOTTERY = 9;
export const REFERRER_REWARD = 10;
export const VOUCHER = 11;

export const PROMOTION_TYPES = [
  { value: DISCOUNT, label: "Giảm giá theo % / số tiền" },
  { value: BUY_X_GET_Y, label: "Mua X tặng Y" },
  { value: COMBO, label: "Combo ưu đãi" },
  { value: FLASH_SALE, label: "Flash Sale" },
  { value: BIRTHDAY, label: "Sinh nhật khách" },
  { value: RETURN_AFTER_X_DAYS, label: "Quay lại sau X ngày" },
  { value: REFERRAL_PROMOTION, label: "Giới thiệu bạn bè" },
  { value: PREPAY, label: "Trả trước nhận ưu đãi" },
  { value: POINT_REWARD, label: "Tặng điểm" },
  { value: LOTTERY, label: "Dự thưởng / bốc thăm" },
  { value: REFERRER_REWARD, label: "Ưu đãi giới thiệu" },
  { value: VOUCHER, label: "Voucher" },
];

export const DAY_MAP = [
  "startOnSunday",
  "startOnMonday",
  "startOnTuesday",
  "startOnWednesday",
  "startOnThursday",
  "startOnFriday",
  "startOnSaturday",
];

export const SERVICE_TREATMENT_TYPE_TREATMENT = 1;
export const SERVICE_TREATMENT_TYPE_WARRANTY = 2;
export const SERVICE_TREATMENT_TYPE_TREATMENT_BY_VOLUME = 3;
export const SERVICE_TREATMENT_TYPE = [
  { value: SERVICE_TREATMENT_TYPE_TREATMENT, name: "Điều trị" },
  { value: SERVICE_TREATMENT_TYPE_WARRANTY, name: "Bảo hành" },
  {
    value: SERVICE_TREATMENT_TYPE_TREATMENT_BY_VOLUME,
    name: "Điều trị theo đơn vị tính",
  },
];

export const STATUS_LOCK_VOUCHER_ITEM_TRUE = true;
export const STATUS_LOCK_VOUCHER_ITEM_FALSE = false;
export const STATUS_LOCK_VOUCHER_ITEM = [
  { name: "Khóa", value: STATUS_LOCK_VOUCHER_ITEM_TRUE },
  { name: "Mở khóa", value: STATUS_LOCK_VOUCHER_ITEM_FALSE },
];

// Loại kỳ lương
export const SALARY_PERIOD_TYPE = {
  PAYROLL_PERIOD: {
    value: 1,
    name: "Kỳ lương tính công cho nhân viên",
    description:
      "Căn cứ vào kỳ lương này để tính công, ca, trả lương cơ bản cho nhân viên, ...",
  },
  COMMISSION_PERIOD: {
    value: 2,
    name: "Kỳ lương tính hoa hồng",
    description:
      "Sử dụng khoảng thời gian của kỳ lương để tính các số liệu trong bảng lương hoa hồng, ...",
  },

  // Trả về danh sách các loại kỳ lương
  getListData: function () {
    return Object.values(this).filter((type) => typeof type === "object");
  },

  // Lấy giá trị theo key (PAYROLL_PERIOD, COMMISSION_PERIOD, ...)
  getValueByKey: function (key) {
    return this[key]?.value || null;
  },

  // Lấy object đầy đủ theo value (ví dụ value = 1)
  getByValue: function (value) {
    return Object.values(this).find((type) => type.value === value) || null;
  },
};

export const VALUE_TAB_CONSTRUCTION_MATERIALS_PRODUCT = 0;
export const VALUE_TAB_CONSTRUCTION_MATERIALS_SUPPLY = 1;

export const VALUE_PLATFORM = ["Facebook", "Zalo", "Tiktok", "Google"];

export const MENU_TYPE_NORMAL = 1;
export const MENU_TYPE_MEGA = 2;
export const EXTERNAL_LINK = 3;
export const EXTERNAL_EMBED_CONTENT = 4;
export const MENU_TYPE = [
  { name: "Menu thường", value: MENU_TYPE_NORMAL },
  { name: "Menu mega", value: MENU_TYPE_MEGA },
  { name: "Liên kết ngoài", value: EXTERNAL_LINK },
  { name: "Nhúng nội dung từ liên kết ngoài", value: EXTERNAL_EMBED_CONTENT },
];

export const ICON_TYPE_MUI_ICON = 1;
export const ICON_TYPE_IMAGE_ICON = 2;
export const ICON_TYPE = [
  { name: "Loại icon của thư viện", value: ICON_TYPE_MUI_ICON },
  { name: "Loại icon của ảnh", value: ICON_TYPE_IMAGE_ICON },
];

export const ICON_NAVIGATION = [
  {
    name: "IconCountry",
    icon: IconCountry,
    value: <IconCountry color="#4276a4" />,
    type: ICON_TYPE_IMAGE_ICON,
  },
  {
    name: "IconEthnics",
    icon: IconEthnics,
    value: <IconEthnics color="#4276a4" />,
    type: ICON_TYPE_IMAGE_ICON,
  },
  {
    name: "IconMapMoney",
    icon: IconMapMoney,
    value: <IconMapMoney color="#4276a4" />,
    type: ICON_TYPE_IMAGE_ICON,
  },
  {
    name: "IconProfession",
    icon: IconProfession,
    value: <IconProfession color="#4276a4" />,
    type: ICON_TYPE_IMAGE_ICON,
  },
  {
    name: "IconServiceRequestSet",
    icon: IconServiceRequestSet,
    value: <IconServiceRequestSet color="#4276a4" />,
    type: ICON_TYPE_IMAGE_ICON,
  },

  {
    name: "IconServiceType",
    icon: IconServiceType,
    value: <IconServiceType color="#4276a4" />,
    type: ICON_TYPE_IMAGE_ICON,
  },
  {
    name: "IconStaff",
    icon: IconStaff,
    value: <IconStaff color="#4276a4" />,
    type: ICON_TYPE_IMAGE_ICON,
  },

  {
    name: "IconUserAccount",
    icon: IconUserAccount,
    value: <IconUserAccount color="#4276a4" />,
    type: ICON_TYPE_IMAGE_ICON,
  },

  {
    name: "IconUserEdit",
    icon: IconUserEdit,
    value: <IconUserEdit color="#4276a4" />,
    type: ICON_TYPE_IMAGE_ICON,
  },
  {
    name: "IconVat",
    icon: IconVat,
    value: <IconVat color="#4276a4" />,
    type: ICON_TYPE_IMAGE_ICON,
  },
  {
    name: "IconDrug",
    icon: IconDrug,
    value: <IconDrug color="#4276a4" />,
    type: ICON_TYPE_IMAGE_ICON,
  },
  {
    name: "IconMedicalEquipment",
    icon: IconMedicalEquipment,
    value: <IconMedicalEquipment color="#4276a4" />,
    type: ICON_TYPE_IMAGE_ICON,
  },

  {
    name: "IconMedicalSupply",
    icon: IconMedicalSupply,
    value: <IconMedicalSupply color="#4276a4" />,
    type: ICON_TYPE_IMAGE_ICON,
  },
  {
    name: "IconConcept",
    icon: IconConcept,
    value: <IconConcept color="#4276a4" />,
    type: ICON_TYPE_IMAGE_ICON,
  },

  {
    name: "EventNoteIcon",
    icon: EventNoteIcon,
    value: <EventNoteIcon color="#4276a4" />,
    type: ICON_TYPE_MUI_ICON,
  },
  {
    name: "GroupIcon",
    icon: GroupIcon,
    value: <GroupIcon color="#4276a4" />,
    type: ICON_TYPE_MUI_ICON,
  },

  {
    name: "MonetizationOnIcon",
    icon: MonetizationOnIcon,
    value: <MonetizationOnIcon color="#4276a4" />,
    type: ICON_TYPE_MUI_ICON,
  },

  {
    name: "PersonOutlineOutlinedIcon",
    icon: PersonOutlineOutlinedIcon,
    value: <PersonOutlineOutlinedIcon color="#4276a4" />,
    type: ICON_TYPE_MUI_ICON,
  },

  {
    name: "SettingsIcon",
    icon: SettingsIcon,
    value: <SettingsIcon color="#4276a4" />,
    type: ICON_TYPE_MUI_ICON,
  },

  {
    name: "AssessmentIcon",
    icon: AssessmentIcon,
    value: <AssessmentIcon color="#4276a4" />,
    type: ICON_TYPE_MUI_ICON,
  },

  {
    name: "BarChartIcon",
    icon: BarChartIcon,
    value: <BarChartIcon color="#4276a4" />,
    type: ICON_TYPE_MUI_ICON,
  },

  {
    name: "DateRangeIcon",
    icon: DateRangeIcon,
    value: <DateRangeIcon color="#4276a4" />,
    type: ICON_TYPE_MUI_ICON,
  },

  {
    name: "EventAvailableIcon",
    icon: EventAvailableIcon,
    value: <EventAvailableIcon color="#4276a4" />,
    type: ICON_TYPE_MUI_ICON,
  },

  {
    name: "LocalOfferIcon",
    icon: LocalOfferIcon,
    value: <LocalOfferIcon color="#4276a4" />,
    type: ICON_TYPE_MUI_ICON,
  },
  {
    name: "CreditCardIcon",
    icon: CreditCardIcon,
    value: <CreditCardIcon color="#4276a4" />,
    type: ICON_TYPE_MUI_ICON,
  },
  {
    name: "EmojiEventsIcon",
    icon: EmojiEventsIcon,
    value: <EmojiEventsIcon color="#4276a4" />,
    type: ICON_TYPE_MUI_ICON,
  },
  {
    name: "EmojiPeopleIcon",
    icon: EmojiPeopleIcon,
    value: <EmojiPeopleIcon color="#4276a4" />,
    type: ICON_TYPE_MUI_ICON,
  },

  {
    name: "AccountBalanceWallet",
    icon: AccountBalanceWallet,
    value: <AccountBalanceWallet color="#4276a4" />,
    type: ICON_TYPE_MUI_ICON,
  },
  {
    name: "AssignmentInd",
    icon: AssignmentInd,
    value: <AssignmentInd color="#4276a4" />,
    type: ICON_TYPE_MUI_ICON,
  },
  {
    name: "AssignmentLate",
    icon: AssignmentLate,
    value: <AssignmentLate color="#4276a4" />,
    type: ICON_TYPE_MUI_ICON,
  },
  {
    name: "AssignmentTurnedIn",
    icon: AssignmentTurnedIn,
    value: <AssignmentTurnedIn color="#4276a4" />,
    type: ICON_TYPE_MUI_ICON,
  },
  {
    name: "ConfirmationNumber",
    icon: ConfirmationNumber,
    value: <ConfirmationNumber color="#4276a4" />,
    type: ICON_TYPE_MUI_ICON,
  },
  {
    name: "Dialpad",
    icon: Dialpad,
    value: <Dialpad color="#4276a4" />,
    type: ICON_TYPE_MUI_ICON,
  },
  {
    name: "GroupAdd",
    icon: GroupAdd,
    value: <GroupAdd color="#4276a4" />,
    type: ICON_TYPE_MUI_ICON,
  },
  {
    name: "HourglassEmpty",
    icon: HourglassEmpty,
    value: <HourglassEmpty color="#4276a4" />,
    type: ICON_TYPE_MUI_ICON,
  },
  {
    name: "List",
    icon: List,
    value: <List color="#4276a4" />,
    type: ICON_TYPE_MUI_ICON,
  },
  {
    name: "ListAltOutlined",
    icon: ListAltOutlined,
    value: <ListAltOutlined color="#4276a4" />,
    type: ICON_TYPE_MUI_ICON,
  },
  {
    name: "MoneyOffOutlined",
    icon: MoneyOffOutlined,
    value: <MoneyOffOutlined color="#4276a4" />,
    type: ICON_TYPE_MUI_ICON,
  },
  {
    name: "Timer",
    icon: Timer,
    value: <Timer color="#4276a4" />,
    type: ICON_TYPE_MUI_ICON,
  },
];

export const POPUP_TYPE_REGISTER_TREATMENT = 1; // Đăng ký liệu trình
export const POPUP_TYPE_PRODUCT = 2; // Sản phẩm
export const POPUP_TYPE_CARD = 3; // Thẻ
export const POPUP_TYPE_SERVICE = 4; // Dịch vụ

export const POPUP_TYPE_CHANGE_TREATMENT = 1; //Đổi liệu trình
export const POPUP_TYPE_CHANGE_CARD = 2; // Đổi Thẻ
export const POPUP_TYPE_CHANGE_SERVICE = 3; //Đổi sản phẩm
export const POPUP_TYPE_CHANGE_PRODUCT = 4; // Đổi dịch vụ

export const CUSTOMER_FIRST_TIME = 1; // Lần đầu (khách mới)
export const CUSTOMER_FAMILIAR = 2; // Quen thuộc (khách cũ)
export const CUSTOMER_REVISIT = 3; // Tái khám
export const MARKETING_TYPE = [
  { name: "Lần đầu - mới", value: CUSTOMER_FIRST_TIME },
  { name: "Quen thuộc - cũ", value: CUSTOMER_FAMILIAR },
  { name: "Tái khám", value: CUSTOMER_REVISIT },
];

// Sensitive image placeholder
export const SENSITIVE_PLACEHOLDER_IMAGE = "/assets/images/sensitive_placeholder.jpg";
